import {
  State,
  Action,
  StateContext,
  Store,
  Selector,
  createSelector,
} from "@ngxs/store";
import CryptoJS from "crypto-js";
import { tap, finalize, switchMap, delay, catchError } from "rxjs/operators";
import { AngularFireStorage } from "@angular/fire/compat/storage";
import { v1 as uuid } from "uuid";
import { of, combineLatest, forkJoin } from "rxjs";
import { produce } from "immer";
import { Navigate } from "@ngxs/router-plugin";
import { AngularFireAuth } from "@angular/fire/compat/auth";
import { environment } from "src/environments/environment";
//import { trace } from "@angular/fire/compat/performance";
import { Inventory, InventoryDetail } from "../interface/admin";
import { UserState } from "./user.state";
import { UpdatePlace } from "./actions/user.actions";
import { AngularFireMessaging } from "@angular/fire/compat/messaging";
import { Injectable } from "@angular/core";
import {
  patch,
  append,
  updateItem,
  removeItem,
  insertItem,
} from "@ngxs/store/operators";
import {
  CleanAdminPage,
  BillsByPlaceAndStateAndIds,
  SetBillStatesFilter,
  GetRolesByPlace,
  GetCellars,
  GetAllBlackBoxDetailType,
  ViewCellarsDesactive,
  CreateCellar,
  CreateInventory,
  GetUsersByPlace,
  FindUsersByPlace,
  GetBlackBoxesByPlace,
  GetTransferBlackBoxesByPlace,
  SearchBlackBoxes,
  SearchTransferBlackBoxes,
  CreateBlackBox,
  UpdateBlackBox,
  SendNotification,
  CreateBlackBoxDetail,
  TransactionBlackBoxDetail,
  UpdateBlackBoxDetail,
  HideBlackBox,
  RestoreBlackBox,
  GetInventories,
  FindFeatures,
  HandleCellarState,
  RemoveInventory,
  GetMeasures,
  CreateInventoryDetail,
  GetInventoryDetail,
  HideInventoryDetail,
  GetProductStates,
  UpdateCellar,
  UpdateInventory,
  UpdateInventoryAll,
  UpdateInventoryDetail,
  RestoreInventoryDetail,
  GetKeysFeatures,
  CreateFeatureFile,
  OpenDialog,
  AddProductDetail,
  UpdateProductDetail,
  RemoveProductDetail,
  AddProductFeature,
  UpdateProductPrice,
  UpdateFeatureQuantity,
  GetPriceHistory,
  RemoveFeatureFile,
  GetFeaturesByDetail,
  TagsByInventoryDetailPlace,
  GetInventoryDetailForSearch,
  AddProductTag,
  RemoveProductTag,
  UpdateInventoryState,
  GenerateFeatureQr,
  GenerateFeatureBarCode,
  GetBillsByPlaceAndState,
  GetBillDetailByBillAndPlace,
  CreateDeliveryForPlaceAdmin,
  GetBillDetailsForDelivery,
  CheckBillDetail,
  UpdateDeliveryToReady,
  UpdateBillDetails,
  UpdateBillDetailsToDelivered,
  FindFeaturesByPlace,
  AddElementToNavigation,
  GetFilesByPlaceAndType,
  ShoppersByPlace,
  FindFeaturesByPlaceForBill,
  ResetTemporalBill,
  SelectDefaultCashierCoin,
  UpdateDefaultCashierCoin,
  GetUserByCriteriaForTemporaryBill,
  ResetChargedClient,
  CreateBillForCashier,
  CheckIfAccountIsEnough,
  GetAllTaxes,
  AssignNewTaxToProduct,
  ResetInsufficientFunds,
  GetInventoriesByPlace,
  CloneInventoryDetail,
  MoveInventoryDetail,
  UpdateRestrictedProduct,
  GetBlackBoxByUser,
  PayWithAccountFromAdmin,
  UpdateBlackBoxDetailOfCashier,
  AddUserToPayment,
  EditUserToPayment,
  DeleteItemOfUsersBill,
  PayBillCashierMultiple,
  CheckWalletsAndPayMultiple,
  FinishMultiplePayment,
  UpdateFeatureLocation,
  GetActiveCellarsByPlace,
  GetAllTariff,
  IsPromotionalCodeValid,
  ResetPromotionalCodeForCashier,
  UpdatePreparationTimeOfProductFeature,
  UpdateCadesurCodeProductFeature,
  SearchTagByCategory,
  TagsByFather,
  FindTags,
  CategoriesTagsClient,
  SubcategoriesTags,
  TagCategories,
  SonTags,
  TagsByCategory,
  UpdateTag,
  GetPromotionalCodes,
  FindTagsToAssign,
  AddSonTag,
  RemoveSonTag,
  AddTag,
  UpdatePromotionalCode,
  UpdatePromotionalCodeState,
  GenerateRandomPromotionalCodeName,
  CreatePromotionalCode,
  CreateProductKeyFeature,
  CreateProductDiscount,
  DiscountsByPlace,
  SetProductDiscount,
  RemoveProductDiscount,
  SubscribeUsers,
  CreateProductFeatureTag,
  RemoveProductFeatureTag,
  Activities,
  SetPlaceDelivery,
  SelectUserBill,
  UsersByCriteria,
  BillsByPlace,
  CreateBillCashier,
  AddBillCashier,
  BillByID,
  UpdateQuantityBillDetailCashier,
  ReduceBillCashier,
  RemoveBillCashier,
  PayBillByCashier,
  QueryCabys,
  PlaceData,
  FeaturesByInventoryDetail,
  FeaturesByInventory,
  FeaturesByCellar,
  QueryFeatures,
  RandomByPlace,
  TagsByInventory,
  FeatureById,
  CleanCurrentFeature,
  DevicesByUser,
  SetDiscountState,
  UpdateFeaturesQuantity,
  UploadImage,
  SaveImageRoute,
  GetDeliveryByUser,
  UpdateBillDetailState,
  UpdateDeliveryMoment,
  GetAllCoins,
  LocationsByPlace,
  UploadPlaceGalleryPicture,
  SaveImageRouteForPlaceGallery,
  SaveGalleryFile,
  BillsPendingState,
  GetCurrentCarts,
  currentCartsBills,
  ActiveUserByPlace,
  getUserByPlace,
  ProductsByCategory,
  ProductsAndCategory,
  RemoveProductsAndFeature,
  createRefundsByBill,
  updateRefundState,
  updateGalleryFileState,
  UpdateProductFeature,
  AllPersonTypes,
  LoadTags,
  SaveTag,
  EditFeatureTag,
  ClearInventoryDetail,
  ResetBillDetail,
  CreateBillOnly,
  RemoveTag,
  UpdateFeatureState,
} from "./actions/admin.actions";
import { ApiService } from "../services/api.service";
import { SetCadesurFeatureFile } from "./actions/reports.actions";
import { AdminStateModel } from "../interface/admin";
import { AlertService } from "../services/alert.service";
import { ElectronicBillModel } from "../interface/electronicBill";
import { DataService } from "../services/data.service";

@State<AdminStateModel>({
  name: "admin",
  defaults: {
    cellars: [],
    allCellars: [],
    inventories: [],
    measures: [],
    inventoryDetail: [],
    productStates: [],
    shoppers: [],
    coins: [],
    keysFeatures: [],
    priceHistory: [],
    featuresFiltered: [],
    orders: [],
    pendingOrders: [],
    readyOrders: [],
    detailOfSelectedBill: [],
    deliveryInfo: null,
    ordersToPrepare: [],
    filteredProducts: [],
    navigationMap: null,
    blackBoxes: [],
    transferBlackBoxes: [],
    blackBoxDetailTypes: [],
    users: [],
    galleryImages: [],
    billStatesFilter: [2, 8],
    temporalBill: null,
    defaultCashierCoin: null,
    userSelected: null,
    insufficientFunds: true,
    taxes: null,
    inventoriesToAssign: [],
    roles: [],
    BlackBox: null,
    transactionState: false,
    usersForBill: [],
    resultsToAddBill: {
      Features: [],
    },
    cellarsForMovement: [],
    tax: [],
    tariff: [],
    cabys: [],
    selectedPromotionalCode: null,
    tags: [],
    tagsFiltered: [],
    categories: null,
    subcategories: null,
    tagsCategory: [],
    usedTags: [],
    promotionalCodes: [],
    tagsToAssign: [],
    randomCode: "",
    tagsByInventoryDetailPlace: [],
    selectedUser: null,
    billingBills: [],
    placeData: {
      Cellars: [],
      Inventories: [],
      InventoriesDetails: [],
    },
    placeActive: [],
    locations: [],
    currentCart: [],
    activeUserByPlace: [],
    findProductsSoldByCategory: [],
    noFeatures: false,
  },
})
@Injectable()
export class AdminState {
  constructor(
    private api: ApiService,
    private store: Store,
    private storage: AngularFireStorage,
    public afAuth: AngularFireAuth,
    private afm: AngularFireMessaging,
    private alertService: AlertService,
    private _dataService: DataService
  ) {}

  @Selector()
  static roles(state: AdminStateModel) {
    return state.roles;
  }

  @Selector()
  static blackBoxes(state: AdminStateModel) {
    return state.blackBoxes;
  }

  @Selector()
  static transferBlackBoxes(state: AdminStateModel) {
    return state.transferBlackBoxes;
  }

  @Selector()
  static users(state: AdminStateModel) {
    return state.users;
  }

  @Selector()
  static allCellars(state: AdminStateModel) {
    return state.allCellars;
  }

  @Selector()
  static cellars(state: AdminStateModel) {
    return state.cellars;
  }

  @Selector()
  static blackBoxDetailTypes(state: AdminStateModel) {
    return state.blackBoxDetailTypes;
  }

  @Selector()
  static inventories(state: AdminStateModel) {
    return state.inventories;
  }

  @Selector()
  static measures(state: AdminStateModel) {
    return state.measures;
  }

  @Selector()
  static inventoryDetail(state: AdminStateModel) {
    return state.inventoryDetail;
  }

  @Selector()
  static productStates(state: AdminStateModel) {
    return state.productStates;
  }

  @Selector()
  static coins(state: AdminStateModel) {
    return state.coins;
  }

  @Selector()
  static keysFeatures(state: AdminStateModel) {
    return state.keysFeatures;
  }

  @Selector()
  static priceHistory(state: AdminStateModel) {
    return state.priceHistory;
  }
  @Selector()
  static personTypes(state: AdminStateModel) {
    return state.personTypes;
  }

  @Selector()
  static featuresFiltered({ featuresFiltered }: AdminStateModel) {
    return featuresFiltered.filter(
      (f) =>
        f.Product.ProductState.id !== "2" &&
        f.Product.Inventory.State_Inventory !== 2 &&
        f.Product.Inventory.Cellar.State_Cellar !== 2
    );
  }

  @Selector()
  static featuresFilteredTrash({ featuresFiltered }: AdminStateModel) {
    return featuresFiltered.filter(
      (f) =>
        f.Product.ProductState.id === "2" ||
        f.Product.Inventory.State_Inventory === 2 ||
        f.Product.Inventory.Cellar.State_Cellar === 2
    );
  }

  @Selector()
  static orders(state: AdminStateModel) {
    return state.orders;
  }

  @Selector()
  static pendingOrders({ pendingOrders }: AdminStateModel) {
    return pendingOrders;
  }

  @Selector()
  static pendingOrdersCount({ pendingOrders }: AdminStateModel) {
    return pendingOrders.length;
  }

  @Selector()
  static activeUserByPlace({ activeUserByPlace }: AdminStateModel) {
    return activeUserByPlace;
  }

  @Selector()
  static activeUserByPlaceCount({ activeUserByPlace }: AdminStateModel) {
    return activeUserByPlace.length;
  }

  @Selector()
  static currentCart({ currentCart }: AdminStateModel) {
    return currentCart;
  }

  @Selector()
  static currentCartCount({ currentCart }: AdminStateModel) {
    return currentCart.length;
  }

  @Selector()
  static findProductsSoldByCategory({
    findProductsSoldByCategory,
  }: AdminStateModel) {
    return findProductsSoldByCategory;
  }

  @Selector()
  static PlaceActive({ placeActive }: AdminStateModel) {
    return placeActive;
  }

  @Selector()
  static readyOrders({ readyOrders }: AdminStateModel) {
    return readyOrders;
  }

  @Selector()
  static detailOfSelectedBill({ detailOfSelectedBill }: AdminStateModel) {
    return detailOfSelectedBill;
  }

  @Selector()
  static deliveryInfo({ deliveryInfo }: AdminStateModel) {
    return deliveryInfo;
  }

  @Selector()
  static ordersToPrepare({ ordersToPrepare }: AdminStateModel) {
    return ordersToPrepare;
  }

  @Selector()
  static filteredProducts(state: AdminStateModel) {
    return state.filteredProducts;
  }

  @Selector()
  static navigationMap(state: AdminStateModel) {
    return state.navigationMap;
  }

  @Selector()
  static billStatesFilter({ billStatesFilter }: AdminStateModel) {
    return billStatesFilter;
  }

  @Selector()
  static galleryImages(state: AdminStateModel) {
    return state.galleryImages;
  }

  @Selector()
  static shoppers({ shoppers }: AdminStateModel) {
    return shoppers;
  }

  @Selector([UserState.me])
  static orderState({ ordersToPrepare }: AdminStateModel) {
    let isNotComplete = false;
    let isNotFounded = false;
    ordersToPrepare.forEach((_detail) => {
      if (_detail.State.id === 4) {
        isNotComplete = true;
      } else if (_detail.State.id === 3) {
        isNotFounded = true;
      }
    });
    return { isNotComplete, isNotFounded };
  }

  @Selector()
  static defaultCashierCoin(state: AdminStateModel) {
    return state.defaultCashierCoin;
  }

  @Selector()
  static userSelected(state: AdminStateModel) {
    return state.userSelected;
  }

  @Selector()
  static insufficientFunds(state: AdminStateModel) {
    return state.insufficientFunds;
  }

  @Selector()
  static taxes(state: AdminStateModel) {
    return state.taxes;
  }

  @Selector()
  static inventoriesToAssign(state: AdminStateModel) {
    return state.inventoriesToAssign;
  }

  @Selector()
  static temporalBill({ temporalBill }: AdminStateModel) {
    return temporalBill;
  }

  @Selector()
  static BlackBox(state: AdminStateModel) {
    return state.BlackBox;
  }

  @Selector()
  static transactionState(state: AdminStateModel) {
    return state.transactionState;
  }

  @Selector()
  static usersForBill(state: AdminStateModel) {
    return state.usersForBill;
  }

  @Selector()
  static resultsToAddBill(state: AdminStateModel) {
    return state.resultsToAddBill;
  }

  @Selector()
  static cellarsForMovement(state: AdminStateModel) {
    return state.cellarsForMovement;
  }

  @Selector()
  static selectedPromotionalCode(state: AdminStateModel) {
    return state.selectedPromotionalCode;
  }

  static promotionInfo(FirebaseId_BillDetail) {
    return createSelector(
      [AdminState],
      ({ ordersToPrepare }: AdminStateModel) => {
        return ordersToPrepare.find(
          (_detail) => _detail.FirebaseId_BillDetail === FirebaseId_BillDetail
        );
      }
    );
  }

  @Selector()
  static tax({ tax }: AdminStateModel) {
    return tax;
  }

  @Selector()
  static tariff({ tariff }: AdminStateModel) {
    return tariff;
  }

  @Selector()
  static tagsFiltered({ tagsFiltered }: AdminStateModel) {
    return tagsFiltered;
  }

  @Selector()
  static categories({ categories }: AdminStateModel) {
    return categories;
  }

  @Selector()
  static subcategories({ subcategories }: AdminStateModel) {
    return subcategories;
  }

  @Selector()
  static tags({ tags }: AdminStateModel) {
    return tags;
  }

  @Selector()
  static usedTags({ usedTags }: AdminStateModel) {
    return usedTags;
  }

  @Selector()
  static tagsCategory({ tagsCategory }: AdminStateModel) {
    return tagsCategory;
  }

  @Selector()
  static promotionalCodes({ promotionalCodes }: AdminStateModel) {
    return promotionalCodes;
  }

  @Selector()
  static tagsToAssign({ tagsToAssign }: AdminStateModel) {
    return tagsToAssign;
  }

  @Selector()
  static discounts({ discounts }: AdminStateModel) {
    return discounts;
  }

  @Selector()
  static serverDate({ serverDate }: AdminStateModel) {
    return serverDate;
  }

  @Selector()
  static tagsByInventoryDetailPlace({
    tagsByInventoryDetailPlace,
  }: AdminStateModel) {
    return tagsByInventoryDetailPlace;
  }

  @Selector()
  static queryUsers({ queryUsers }: AdminStateModel) {
    return queryUsers;
  }

  @Selector()
  static billingBills({ billingBills }: AdminStateModel) {
    return billingBills;
  }

  @Selector()
  static cabys({ cabys }: AdminStateModel) {
    return cabys;
  }

  @Selector()
  static placeData({ placeData }: AdminStateModel) {
    return placeData;
  }

  @Selector()
  static placeCellar({ placeData: { Cellars } }: AdminStateModel) {
    return Cellars;
  }

  @Selector()
  static placeInventories({ placeData: { Inventories } }: AdminStateModel) {
    return Inventories;
  }

  @Selector()
  static placeInventoriesDetails({
    placeData: { InventoriesDetails },
  }: AdminStateModel) {
    return InventoriesDetails;
  }

  @Selector()
  static currentProductFeature({ currentProductFeature }: AdminStateModel) {
    return currentProductFeature;
  }

  @Selector()
  static devicesByUser({ devicesByUser }: AdminStateModel) {
    return devicesByUser;
  }

  @Selector()
  static locations({ locations }: AdminStateModel) {
    return locations;
  }

  @Selector()
  static noFeatures(state: AdminStateModel): boolean {
    return state.noFeatures;
  }

  @Action(CleanAdminPage)
  cleanHomePage({ patchState }: StateContext<AdminStateModel>) {
    patchState({
      cellars: [],
      allCellars: [],
      inventories: [],
      measures: [],
      inventoryDetail: [],
      productStates: [],
      shoppers: [],
      coins: [],
      keysFeatures: [],
      priceHistory: [],
      featuresFiltered: [],
      orders: [],
      detailOfSelectedBill: [],
      deliveryInfo: null,
      ordersToPrepare: [],
      filteredProducts: [],
      navigationMap: null,
      blackBoxes: [],
      transferBlackBoxes: [],
      blackBoxDetailTypes: [],
      users: [],
      galleryImages: [],
      billStatesFilter: [2, 8],
      temporalBill: null,
      defaultCashierCoin: null,
      userSelected: null,
      insufficientFunds: true,
      taxes: null,
      inventoriesToAssign: [],
      roles: [],
      BlackBox: null,
      transactionState: false,
      usersForBill: [],
      discounts: [],
      locations: [],
      pendingOrders: [],
      readyOrders: [],
      placeActive: [],
      currentCart: [],
      activeUserByPlace: [],
      findProductsSoldByCategory: [],
      noFeatures: false,
    });
  }

  @Action(ActiveUserByPlace)
  getActiveUserByPlace({ dispatch }: StateContext<AdminState>) {
    const place = this.store.selectSnapshot(UserState.selectedPlace);

    dispatch(new getUserByPlace(place.id));
  }

  @Action(ProductsByCategory)
  getProductsByCategory({ dispatch }: StateContext<AdminState>) {
    const place = this.store.selectSnapshot(UserState.selectedPlace);

    dispatch(new ProductsAndCategory(place.id));
  }

  @Action(GetCurrentCarts)
  getCurrentCarts({ dispatch }: StateContext<AdminState>) {
    const place = this.store.selectSnapshot(UserState.selectedPlace);
    dispatch(new currentCartsBills(place.id));
  }

  @Action(ProductsAndCategory)
  productsAndCategory(
    { patchState }: StateContext<AdminStateModel>,
    { place }: ProductsAndCategory
  ) {
    return this.api.getProductByCategory(place).pipe(
      tap(({ data: { productsByCategory } }) => {
        patchState({
          findProductsSoldByCategory: productsByCategory,
        });
      })
    );
  }

  @Action(getUserByPlace)
  userByPlace(
    { patchState }: StateContext<AdminStateModel>,
    { place }: getUserByPlace
  ) {
    return this.api.getUserByPlace(place).pipe(
      tap(({ data: { userActiveByPlace } }) => {
        patchState({
          activeUserByPlace: userActiveByPlace,
        });
      })
    );
  }

  @Action(currentCartsBills)
  billCurrentCarts(
    { patchState }: StateContext<AdminStateModel>,
    { place }: currentCartsBills
  ) {
    return this.api.billCurrentCart(place).pipe(
      tap(({ data: { billCurrentCart } }) => {
        patchState({
          currentCart: billCurrentCart,
        });
      })
    );
  }

  @Action(BillsPendingState)
  billPendingStateAndId(
    { patchState }: StateContext<AdminStateModel>,
    { place, stateFilter, idsBills }: BillsPendingState
  ) {
    return this.api.billPendingStateAndId(place, stateFilter, idsBills).pipe(
      tap(({ data: { bills } }) => {
        if (bills) {
          patchState({
            pendingOrders: bills,
          });
        }
      })
    );
  }

  @Action(BillsByPlaceAndStateAndIds)
  billsByPlaceAndStateAndIds(
    { patchState }: StateContext<AdminStateModel>,
    {
      place,
      billDetailState,
      statesFilter,
      details,
    }: BillsByPlaceAndStateAndIds
  ) {
    return this.api
      .billsByPlaceAndStateAndIds(place, statesFilter, billDetailState, details)
      .pipe(
        tap(({ data: { bills } }) => {
          patchState({ orders: bills });
          Notification.requestPermission().then((result) => {
            if (result === "denied") {
              console.log("Permission wasn't granted. Allow a retry.");
              return;
            }
            if (result === "default") {
              console.log("The permission request was dismissed.");
              return;
            }
            if (bills && bills.length > 0) {
              Notification.requestPermission((_result) => {
                if (_result === "granted") {
                  navigator.serviceWorker.ready
                    .then((registration) => {
                      registration.showNotification("Nuevas órdenes", {
                        body: `Existen ${bills.length} órdenes pendientes`,
                        tag: "orders",
                      });
                    })
                    .catch((er) => {
                      console.log(er);
                    });
                }
              });
            }
          });
        })
      );
  }

  @Action(SetBillStatesFilter)
  setBillStatesFilter(
    { patchState }: StateContext<AdminStateModel>,
    { billStatesFilter }: SetBillStatesFilter
  ) {
    patchState({ billStatesFilter });
  }

  @Action(GetRolesByPlace)
  getRolesByPlace({ patchState }: StateContext<AdminStateModel>) {
    const token = this.store.selectSnapshot(UserState.token);
    const { id } = this.store.selectSnapshot(UserState.selectedPlace);
    return this.api.getRolesByPlace(id).pipe(
      tap(
        ({ data: { roles } }) => patchState({ roles }),
        () =>
          this.alertService.openSnackBar(
            "Error al obtener los roles de lugar.",
            "error"
          )
      )
      //trace("GetRolesByPlace")
    );
  }

  @Action(GetCellars)
  GetCellars({ patchState, setState }: StateContext<AdminStateModel>) {
    const token = this.store.selectSnapshot(UserState.token);
    const { id } = this.store.selectSnapshot(UserState.selectedPlace);
    return this.api.getCellars(id).pipe(
      tap(
        ({ data: { cellars } }) =>
          setState(
            patch({
              allCellars: cellars,
              cellars: cellars.filter((cellar) => cellar.State_Cellar === 1),
            })
          ),
        () => {
          this.alertService.openSnackBar(
            "Error al obtener las bodegas.",
            "error"
          );
        }
      )
      //trace("GetCellars")
    );
  }

  @Action(GetAllBlackBoxDetailType)
  getAllBlackBoxDetailType({ patchState }: StateContext<AdminStateModel>) {
    const token = this.store.selectSnapshot(UserState.token);
    return this.api.getAllBlackBoxDetailType().pipe(
      tap(
        ({ data: { blackBoxDetailTypes } }) =>
          patchState({ blackBoxDetailTypes }),
        () => {
          this.alertService.openSnackBar(
            "Error al obtener los tipos de detalle de la caja negra.",
            "error"
          );
        }
      )
      //trace("GetAllBlackBoxDetailType")
    );
  }

  @Action(ViewCellarsDesactive)
  ViewCellarsDesactive(
    { patchState, getState }: StateContext<AdminStateModel>,
    { viewDesactive }: ViewCellarsDesactive
  ) {
    patchState({
      cellars: getState().allCellars.filter((cellar) =>
        viewDesactive ? cellar.State_Cellar === 2 : cellar.State_Cellar === 1
      ),
    });
  }

  @Action(CreateCellar)
  createCellar(
    { patchState, getState, setState }: StateContext<AdminStateModel>,
    { newCellar }: CreateCellar
  ) {
    const { cellars, allCellars } = getState();
    const { id } = this.store.selectSnapshot(UserState.selectedPlace);
    return this.api
      .createCellar({
        ...newCellar,
        FK_Place: id,
        Color: newCellar.Color || undefined,
      })
      .pipe(
        tap(
          ({ data: { cellar } }) => {
            if (cellar.State_Cellar === 1) {
              patchState({
                allCellars: [...allCellars, { ...cellar }],
                cellars: [...cellars, { ...cellar }],
              });
            } else {
              patchState({
                allCellars: [...allCellars, { ...cellar }],
              });
            }

            setState(
              patch({
                placeData: patch({
                  Cellars: append([{ ...cellar }]),
                }),
              })
            );
            this.alertService.openSnackBar(
              "Se ha creado una bodega con éxito.",
              "success"
            );
          },
          () => {
            this.alertService.openSnackBar(
              "Error al crear la bodega.",
              "error"
            );
            return of(null);
          }
        )
      );
  }

  @Action(CreateInventory)
  createInventory(
    { getState, patchState, setState }: StateContext<AdminStateModel>,
    { newInventory }: CreateInventory
  ) {
    const token = this.store.selectSnapshot(UserState.token);
    const { inventories } = getState();
    return this.api.createInventory(newInventory).pipe(
      tap(
        ({ data: { inventory } }) => {
          setState(
            patch({ placeData: patch({ Inventories: append([inventory]) }) })
          );
          patchState({ inventories: [...inventories, inventory] });
          this.alertService.openSnackBar(
            "Inventario creado con éxito.",
            "success"
          );
        },
        () => {
          this.alertService.openSnackBar(
            "Error al crear el inventario.",
            "error"
          );
          return of(null);
        }
      )
      //trace("CreateInventory")
    );
  }

  @Action(GetUsersByPlace)
  getUsersByPlace({ patchState }: StateContext<AdminStateModel>) {
    const token = this.store.selectSnapshot(UserState.token);
    const { id } = this.store.selectSnapshot(UserState.selectedPlace);
    return this.api.getUsersByPlace(id).pipe(
      tap(
        ({ data: { users } }) => {
          patchState({ users });
        },
        () =>
          this.alertService.openSnackBar(
            "Error al obtener los usuarios.",
            "error"
          )
      )
      //trace("")
    );
  }

  @Action(FindUsersByPlace)
  findUsersByPlace(
    { patchState }: StateContext<AdminStateModel>,
    { criteria }: FindUsersByPlace
  ) {
    const token = this.store.selectSnapshot(UserState.token);
    const { id } = this.store.selectSnapshot(UserState.selectedPlace);
    return this.api.findUsersByPlace(criteria, id).pipe(
      tap(
        ({ data: { users } }) => {
          patchState({ users });
        },
        () => this.alertService.openSnackBar("Error de conexión.", "error")
      )
      //trace("FindUsersByPlace")
    );
  }

  @Action(GetBlackBoxesByPlace)
  getBlackBoxesByPlace({ patchState }: StateContext<AdminStateModel>) {
    const token = this.store.selectSnapshot(UserState.token);
    const { id } = this.store.selectSnapshot(UserState.selectedPlace);
    return this.api.getBlackBoxesByPlace(id).pipe(
      tap(
        ({ data: { blackBoxes } }) => {
          patchState({ blackBoxes });
        },
        () =>
          this.alertService.openSnackBar(
            "Error al encontrar cajas negras.",
            "error"
          )
      )
      //trace("GetBlackBoxesByPlace")
    );
  }

  @Action(GetTransferBlackBoxesByPlace)
  getTransferBlackBoxesByPlace({ patchState }: StateContext<AdminStateModel>) {
    const token = this.store.selectSnapshot(UserState.token);
    const { id } = this.store.selectSnapshot(UserState.selectedPlace);
    return this.api.getBlackBoxesByPlace(id).pipe(
      tap(
        ({ data: { blackBoxes } }) => {
          patchState({ transferBlackBoxes: blackBoxes });
        },
        () =>
          this.alertService.openSnackBar(
            "Error al encontrar cajas negras.",
            "error"
          )
      )
      //trace("GetTransferBlackBoxesByPlace")
    );
  }

  @Action(SearchBlackBoxes)
  searchBlackBoxes(
    { patchState }: StateContext<AdminStateModel>,
    { criteria }: SearchBlackBoxes
  ) {
    const token = this.store.selectSnapshot(UserState.token);
    const { id } = this.store.selectSnapshot(UserState.selectedPlace);
    return this.api.searchBlackBoxes(criteria, id).pipe(
      tap(
        ({ data: { blackBoxes } }) => {
          patchState({ blackBoxes });
        },
        () =>
          this.alertService.openSnackBar(
            "Error al encontrar cajas negras.",
            "error"
          )
      )
      //trace("SearchBlackBoxes")
    );
  }

  @Action(SearchTransferBlackBoxes)
  searchTransferBlackBoxes(
    { patchState }: StateContext<AdminStateModel>,
    { criteria }: SearchTransferBlackBoxes
  ) {
    const token = this.store.selectSnapshot(UserState.token);
    const { id } = this.store.selectSnapshot(UserState.selectedPlace);
    return this.api.searchBlackBoxes(criteria, id).pipe(
      tap(
        ({ data: { blackBoxes } }) => {
          patchState({ transferBlackBoxes: blackBoxes });
        },
        () =>
          this.alertService.openSnackBar(
            "Error al encontrar cajas negras.",
            "error"
          )
      )
      //trace("SearchTransferBlackBoxes")
    );
  }

  @Action(CreateBlackBox)
  createBlackBox(
    { getState, patchState }: StateContext<AdminStateModel>,
    { blackBoxInput }: CreateBlackBox
  ) {
    const token = this.store.selectSnapshot(UserState.token);
    const { blackBoxes } = getState();
    return this.api.createBlackBox(blackBoxInput).pipe(
      tap(
        ({ data: { newBlackBox } }) => {
          patchState({ blackBoxes: [...blackBoxes, newBlackBox] });
          this.alertService.openSnackBar(
            "Caja negra creada con éxito.",
            "success"
          );
        },
        () =>
          this.alertService.openSnackBar(
            "Error al crear la caja negra.",
            "error"
          )
      )
      //trace("CreateBlackBox")
    );
  }

  @Action(UpdateBlackBox)
  updateBlackBox(
    { getState, patchState }: StateContext<AdminStateModel>,
    { blackBoxInput }: UpdateBlackBox
  ) {
    const token = this.store.selectSnapshot(UserState.token);
    const { blackBoxes } = getState();
    return this.api.updateBlackBox(blackBoxInput).pipe(
      tap(
        ({ data: { editedBlackBox } }) => {
          patchState({
            blackBoxes: blackBoxes.map((_blacBox) =>
              _blacBox.id === blackBoxInput.id ? editedBlackBox : _blacBox
            ),
          });
          this.alertService.openSnackBar(
            "Caja negra actualizada con éxito.",
            "success"
          );
        },
        () =>
          this.alertService.openSnackBar(
            "Error al actualizar la caja negra.",
            "error"
          )
      )
      //trace("UpdateBlackBox")
    );
  }

  @Action(SendNotification)
  sendNotification(
    {}: StateContext<AdminStateModel>,
    { notification }: SendNotification
  ) {
    const token = this.store.selectSnapshot(UserState.token);
    return this.api.sendNotification(notification).pipe(
      tap(
        ({ data: { count } }) => {
          this.alertService.openSnackBar(
            `Notificación enviada a ${count} personas con éxito`,
            "success"
          );
        },
        () => {
          this.alertService.openSnackBar(
            "Error al enviar la notificación.",
            "error"
          );
        }
      )
      //trace("SendNotification")
    );
  }

  @Action(CreateBlackBoxDetail)
  createBlackBoxDetail(
    { getState, patchState }: StateContext<AdminStateModel>,
    { blackBoxDetailInput }: CreateBlackBoxDetail
  ) {
    const token = this.store.selectSnapshot(UserState.token);
    const { blackBoxes } = getState();
    blackBoxDetailInput.Value_BlackBoxDetail = CryptoJS.AES.encrypt(
      blackBoxDetailInput.Value_BlackBoxDetail.toString(),
      environment.cryptoAES
    ).toString();
    return this.api.createBlackBoxDetail(blackBoxDetailInput).pipe(
      tap(
        ({ data: { newBlackBoxDetail } }) => {
          patchState({
            blackBoxes: blackBoxes.map((_blackBox) =>
              _blackBox.id === blackBoxDetailInput.FK_BlackBox
                ? {
                    ..._blackBox,
                    BlackBoxDetails: _blackBox.BlackBoxDetails
                      ? [..._blackBox.BlackBoxDetails, newBlackBoxDetail]
                      : [newBlackBoxDetail],
                  }
                : _blackBox
            ),
          });
          this.alertService.openSnackBar(
            "Detalle de caja negra creada con éxito.",
            "error"
          );
        },
        () =>
          this.alertService.openSnackBar(
            "Error al crear el detalle de la caja negra.",
            "error"
          )
      )
      //trace("CreateBlackBoxDetail")
    );
  }

  @Action(TransactionBlackBoxDetail)
  transactionBlackBoxDetail(
    {}: StateContext<AdminStateModel>,
    { from, to, value }: TransactionBlackBoxDetail
  ) {
    const token = this.store.selectSnapshot(UserState.token);
    value = CryptoJS.AES.encrypt(
      value.toString(),
      environment.cryptoAES
    ).toString();
    return this.api.transactionBlackBoxDetail(from, to, value).pipe(
      tap(
        () => null,
        () =>
          this.alertService.openSnackBar(
            "Error al crear el detalle de la caja negra.",
            "error"
          )
      )
      //trace("TransactionBlackBoxDetail")
    );
  }

  @Action(UpdateBlackBoxDetail)
  updateBlackBoxDetail(
    { getState, patchState }: StateContext<AdminStateModel>,
    { blackBoxDetailInput }: UpdateBlackBoxDetail
  ) {
    const token = this.store.selectSnapshot(UserState.token);
    const { blackBoxes } = getState();
    blackBoxDetailInput.Value = CryptoJS.AES.encrypt(
      blackBoxDetailInput.Value.toString(),
      environment.cryptoAES
    ).toString();
    blackBoxDetailInput.Value_BlackBoxDetail = null;
    return this.api.updateBlackBoxDetailForAdmin(blackBoxDetailInput).pipe(
      tap(
        ({ data: { editedBlackBoxDetail } }) => {
          patchState({
            blackBoxes: blackBoxes.map((_blackBox) =>
              _blackBox.id === blackBoxDetailInput.FK_BlackBox
                ? {
                    ..._blackBox,
                    BlackBoxDetails: _blackBox.BlackBoxDetails.map(
                      (blackBoxDetail) =>
                        blackBoxDetail.id === editedBlackBoxDetail.id
                          ? editedBlackBoxDetail
                          : blackBoxDetail
                    ),
                  }
                : _blackBox
            ),
          });
        },
        () =>
          this.alertService.openSnackBar(
            "Error al crear el detalle de la caja negra.",
            "error"
          )
      )
      //trace("UpdateBlackBoxDetail")
    );
  }

  @Action(HideBlackBox)
  hideBlackBox({}: StateContext<AdminStateModel>, { id }: HideBlackBox) {
    const token = this.store.selectSnapshot(UserState.token);
    return this.api.hideBlackBox(id).pipe(
      tap(null, () => {
        this.alertService.openSnackBar("Error de conexión.", "error");
      })
      //trace("HideBlackBox")
    );
  }

  @Action(RestoreBlackBox)
  restoreBlackBox({}: StateContext<AdminStateModel>, { id }: RestoreBlackBox) {
    const token = this.store.selectSnapshot(UserState.token);
    return this.api.restoreBlackBox(id).pipe(
      tap(null, () =>
        this.alertService.openSnackBar(
          "Error al crear el detalle de la caja negra.",
          "error"
        )
      )
      //trace("RestoreBlackBox")
    );
  }

  @Action(GetInventories)
  getInventories(
    { patchState }: StateContext<AdminStateModel>,
    { id }: GetInventories
  ) {
    const { selectedPlace } = this.store.selectSnapshot(UserState);
    if (selectedPlace) {
      return this.api.getInventories(id, selectedPlace.id).pipe(
        tap(
          ({ data: { inventories } }) => {
            patchState({ inventories, inventoryDetail: [] });
          },
          () => {
            this.alertService.openSnackBar(
              "Error al obtener los inventarios.",
              "error"
            );
          }
        )
        //trace("GetInventories")
      );
    }
  }

  @Action(FindFeatures)
  FindFeatures(
    { patchState }: StateContext<AdminStateModel>,
    { criteria }: FindFeatures
  ) {
    const token = this.store.selectSnapshot(UserState.token);
    const { id } = this.store.selectSnapshot(UserState.selectedPlace);
    return this.api.findFeaturesByPlace(criteria, id).pipe(
      tap(
        ({ data: { featuresFiltered } }) => {
          patchState({ featuresFiltered });
        },
        () =>
          this.alertService.openSnackBar(
            "Error al encontrar características.",
            "error"
          )
      )
      //trace("FindFeatures")
    );
  }

  @Action(HandleCellarState)
  handleCellarState(
    { setState, getState, patchState }: StateContext<AdminStateModel>,
    { id, state }: HandleCellarState
  ) {
    const token = this.store.selectSnapshot(UserState.token);
    return this.api.handleCellarState(id, state).pipe(
      tap(
        ({ data: { changed } }) => {
          if (changed) {
            const allCellars = getState().allCellars.map((cellar) =>
              cellar.id === id ? { ...cellar, State_Cellar: state } : cellar
            );
            patchState({
              allCellars,
              cellars: getState().cellars.filter((cellar) => cellar.id !== id),
            });
            setState(
              produce(getState(), ({ featuresFiltered }) => {
                featuresFiltered
                  .filter((x) => x.Product.Inventory.Cellar.id === id)
                  .map(
                    (feature) =>
                      (feature.Product.Inventory.Cellar.State_Cellar = state)
                  );
              })
            );
            setState(
              patch({
                placeData: patch({
                  Cellars: updateItem<any>(
                    (xCellar) => xCellar.id === id,
                    patch({ State_Cellar: state })
                  ),
                }),
              })
            );
            setState(
              patch({
                featuresFiltered: updateItem<any>(
                  (f) => f.Product.Inventory.Cellar.id === id,
                  patch({
                    Product: patch({
                      Inventory: patch({
                        Cellar: patch({ State_Cellar: state }),
                      }),
                    }),
                  })
                ),
              })
            );
            const message =
              state === 2
                ? "Se ha desactivado la bodega con éxito."
                : "Se ha activado la bodega con éxito.";

            this.alertService.openSnackBar(message, "success");
          }
        },
        () => {
          this.alertService.openSnackBar(
            "Error al cambiar el estado de la bodega.",
            "error"
          );
        }
      )
      //trace("HandleCellarState")
    );
  }

  @Action(RemoveInventory)
  removeInventory(
    { patchState, getState }: StateContext<AdminStateModel>,
    { id }: RemoveInventory
  ) {
    const token = this.store.selectSnapshot(UserState.token);
    return this.api.removeInventory(id).pipe(
      tap(
        ({ data: { inventory } }) => {
          if (inventory) {
            const inventories = getState().inventories.filter(
              (inventoryDelete) => inventoryDelete.id !== id
            );
            patchState({ inventories });
            this.alertService.openSnackBar(
              "Inventario desactivado con éxito.",
              "success"
            );
          }
        },
        () =>
          this.alertService.openSnackBar(
            "Error al remover el inventario.",
            "error"
          )
      )
      //trace("RemoveInventory")
    );
  }

  @Action(GetMeasures)
  getMeasures({ patchState }: StateContext<AdminStateModel>) {
    return this.api.getMeasures().pipe(
      tap(
        ({ data: { measures } }) => {
          if (measures) {
            patchState({ measures });
          }
        },
        () =>
          this.alertService.openSnackBar(
            "Error al obtener las unidades de medida.",
            "error"
          )
      )
      // //trace("GetMeasures")
    );
  }

  @Action(CreateInventoryDetail)
  createInventoryDetail(
    { getState, patchState, setState, dispatch }: StateContext<AdminStateModel>,
    { newInventoryDetail, fetchDetails }: CreateInventoryDetail
  ) {
    const token = this.store.selectSnapshot(UserState.token);
    const { inventoryDetail } = getState();
    return this.api.createInventoryDetail(newInventoryDetail).pipe(
      tap(
        () => {
          this.alertService.openSnackBar(
            "Se ha creado una marca con éxito.",
            "success"
          );
        },
        () => {
          this.alertService.openSnackBar("Error al crear una marca.", "error");
          return of(null);
        }
      )
      //trace("CreateInventoryDetail")
    );
  }

  @Action(GetInventoryDetail)
  getInventoryDetail(
    { patchState }: StateContext<AdminStateModel>,
    { id }: GetInventoryDetail
  ) {
    const { selectedPlace } = this.store.selectSnapshot(UserState);
    if (selectedPlace) {
      return this.api.productsByInventory(id, selectedPlace.id).pipe(
        tap(
          ({ data: { products } }) =>
            patchState({
              inventoryDetail: products.map((p) => ({
                ...p,
                Product: { ...p.Product, Features: [] },
              })),
            }),
          () => {
            this.alertService.openSnackBar(
              "Error al obtener el detalle del inventario.",
              "error"
            );
          }
        )
        //trace("GetInventoryDetail")
      );
    }
  }

  @Action(HideInventoryDetail)
  hideInventoryDetail(
    { setState, getState }: StateContext<AdminStateModel>,
    { id }: HideInventoryDetail
  ) {
    const token = this.store.selectSnapshot(UserState.token);
    return this.api.hideProduct(id).pipe(
      tap(
        ({ data: { detail } }) => {
          if (detail) {
            setState(
              patch({
                inventoryDetail: updateItem<any>(
                  (i) => i.id === detail.id,
                  patch({
                    Product: detail.Product,
                  })
                ),
              })
            );
            setState(
              patch({
                placeData: patch({
                  InventoriesDetails: updateItem<any>(
                    (xDetail) => xDetail.id === detail.id,
                    patch({
                      Product: patch({
                        ProductState: detail.Product.ProductState,
                      }),
                    })
                  ),
                }),
              })
            );
            setState(
              produce(getState(), ({ featuresFiltered }) => {
                featuresFiltered
                  .filter(
                    (xFeature) => xFeature.Product.id === detail.Product.id
                  )
                  .forEach((xFeature) => {
                    xFeature.Product.ProductState = detail.Product.ProductState;
                  });
              })
            );
            this.alertService.openSnackBar(
              "Se ha desactivado la marca con éxito.",
              "success"
            );
          }
        },
        () => {
          this.alertService.openSnackBar(
            "Error al cambiar el estado de la marca.",
            "error"
          );
        }
      )
      //trace("HidePromotion")
    );
  }

  @Action(GetProductStates)
  productStates({ patchState }: StateContext<AdminStateModel>) {
    return this.api.productStates().pipe(
      tap(
        ({ data: { states } }) => {
          patchState({ productStates: states });
        },
        () =>
          this.alertService.openSnackBar(
            "Error al obtener los estados del producto.",
            "error"
          )
      )
      //trace("GetProductStates")
    );
  }

  @Action(UpdateCellar)
  updateCellar(
    { getState, patchState, setState }: StateContext<AdminStateModel>,
    { cellarUpdate }: UpdateCellar
  ) {
    const { id } = this.store.selectSnapshot(UserState.selectedPlace);
    const { cellars, allCellars } = getState();
    return this.api.updateCellar({ ...cellarUpdate, FK_Place: id }).pipe(
      tap(
        ({ data: { cellar } }) => {
          setState(
            patch({
              placeData: patch({
                Cellars: updateItem<any>(
                  (xCellar) => xCellar.id === cellarUpdate.id,
                  patch(cellar)
                ),
              }),
            })
          );
          patchState({
            allCellars: allCellars.map((xCellar) =>
              xCellar.id === cellarUpdate.id ? cellar : xCellar
            ),
          });
          if (Number(cellar.State_Cellar) === 1) {
            setState(
              patch({
                cellars: updateItem<any>(
                  (xCellar) => xCellar.id === cellarUpdate.id,
                  patch(cellar)
                ),
              })
            );
          } else {
            patchState({
              cellars: cellars.filter(
                (xCellar) => xCellar.id !== cellarUpdate.id
              ),
            });
          }
          this.alertService.openSnackBar(
            "Bodega actualizada con éxito.",
            "success"
          );
        },
        () => {
          this.alertService.openSnackBar(
            "Error al actualizar la bodega.",
            "error"
          );
        }
      )
      //trace("UpdateCellar")
    );
  }

  @Action(UpdateInventory)
  updateInventory(
    { setState }: StateContext<AdminStateModel>,
    { inventoryUpdate }: UpdateInventory
  ) {
    const token = this.store.selectSnapshot(UserState.token);
    return this.api.updateInventory(inventoryUpdate).pipe(
      tap(
        ({ data: { inventory } }) => {
          setState(
            patch({
              placeData: patch({
                Inventories: updateItem<any>(
                  (xInventory) => xInventory.id === inventory.id,
                  inventory
                ),
              }),
            })
          );
          setState(
            patch({
              inventories: updateItem<any>(
                (i) => i.id === inventory.id,
                inventory
              ),
            })
          );
          this.alertService.openSnackBar(
            "Inventario actualizado con éxito.",
            "success"
          );
        },
        () => {
          this.alertService.openSnackBar(
            "Error al actualizar el inventario.",
            "error"
          );
        }
      )
      //trace("UpdateInventory")
    );
  }

  @Action(UpdateInventoryDetail)
  updateInventoryDetail(
    { getState, patchState, setState }: StateContext<AdminStateModel>,
    { detailUpdate }: UpdateInventoryDetail
  ) {
    const token = this.store.selectSnapshot(UserState.token);
    return this.api.updateInventoryDetail(detailUpdate).pipe(
      tap(
        ({ data: { detail } }) => {
          setState(
            patch({
              inventoryDetail: updateItem<any>(
                (xD) => xD.id === detail.id,
                detail
              ),
            })
          );
          setState(
            patch({
              placeData: patch({
                InventoriesDetails: updateItem<any>(
                  (xD) => xD.id === detail.id,
                  detail
                ),
              }),
            })
          );

          this.alertService.openSnackBar(
            "Se ha actualizado la marca con éxito.",
            "success"
          );
        },
        () => {
          this.alertService.openSnackBar(
            "Error al actualizar la marca.",
            "error"
          );
          return of(null);
        }
      )
      //trace("UpdateInventoryDetail")
    );
  }

  @Action(ClearInventoryDetail)
  clearInventoryDetail(ctx: StateContext<AdminStateModel>) {
    ctx.patchState({ inventoryDetail: [] });
  }

  @Action(RestoreInventoryDetail)
  restoreInventoryDetail(
    { setState, getState }: StateContext<AdminStateModel>,
    { detailRestore }: RestoreInventoryDetail
  ) {
    return this.api.restoreInventoryDetail(detailRestore).pipe(
      tap(
        ({ data: { detail } }) => {
          if (detail) {
            setState(
              patch({
                placeData: patch({
                  InventoriesDetails: updateItem<any>(
                    (xDetail) => xDetail.id === detail.id,
                    patch({
                      Product: patch({
                        ProductState: detail.Product.ProductState,
                      }),
                    })
                  ),
                }),
              })
            );
            setState(
              produce(getState(), ({ featuresFiltered }) => {
                featuresFiltered
                  .filter(
                    (xFeature) => xFeature.Product.id === detail.Product.id
                  )
                  .forEach((xFeature) => {
                    xFeature.Product.ProductState = detail.Product.ProductState;
                  });
              })
            );

            this.alertService.openSnackBar(
              "Se ha activado la marca con éxito.",
              "success"
            );
          }
        },
        () => {
          this.alertService.openSnackBar(
            "Error al cambiar el estado de la marca.",
            "error"
          );
        }
      )
      //trace("RestoreInventoryDetail")
    );
  }

  @Action(GetAllCoins)
  getCoins({ patchState }: StateContext<AdminStateModel>) {
    return this.api.allCoins().pipe(
      tap(
        ({ data: { coins } }) => {
          if (coins) {
            patchState({ coins });
          }
        },
        () => {
          this.alertService.openSnackBar(
            "Error al obtener las monedas.",
            "error"
          );
        }
      )
      // trace("GetCoins")
    );
  }

  @Action(GetKeysFeatures)
  getKeysFeatures({ patchState }: StateContext<AdminStateModel>) {
    return this.api.getKeysFeatures().pipe(
      tap(
        ({ data: { keysFeatures } }) => {
          if (keysFeatures) {
            patchState({ keysFeatures });
          }
        },
        () =>
          this.alertService.openSnackBar(
            "Error al obtener las llaves de los features.",
            "error"
          )
      )
      //trace("GetKeysFeatures")
    );
  }

  @Action(UploadPlaceGalleryPicture)
  UploadPlaceGalleryPicture(
    { dispatch }: StateContext<AdminStateModel>,
    { file }: UploadPlaceGalleryPicture
  ) {
    const { selectedPlace } = this.store.selectSnapshot(UserState);
    const uuidImage = uuid();
    const FirebaseId = `places/place_${selectedPlace.id}/${environment.bucket_place}gallery/gallery-${uuidImage}`;
    const fileRef = this.storage.ref(FirebaseId);
    const uploadTask = this.storage.upload(
      `places/place_${selectedPlace.id}/${environment.bucket_place}gallery/gallery-${uuidImage}`,
      file
    );
    return uploadTask.snapshotChanges().pipe(
      finalize(() =>
        dispatch(
          new SaveImageRouteForPlaceGallery(
            fileRef.getDownloadURL(),
            FirebaseId,
            selectedPlace.id
          )
        )
      )
      //trace("UploadPlaceGalleryPicture")
    );
  }

  @Action(SaveImageRouteForPlaceGallery)
  SaveImageRouteForPlaceGallery(
    { dispatch }: StateContext<AdminStateModel>,
    { fileRef, FirebaseId, PlaceId }: SaveImageRouteForPlaceGallery
  ) {
    return fileRef.pipe(
      tap(
        (url) => {
          dispatch(new SaveGalleryFile(url, FirebaseId, PlaceId));
        },
        () => {
          this.alertService.openSnackBar("Error al subir la imagen.", "error");
        }
      )
      //trace("SaveImageRouteForPlaceGallery")
    );
  }

  @Action(SaveGalleryFile)
  SaveGalleryFile(
    { setState }: StateContext<AdminStateModel>,
    { FilePath, FirebaseId, PlaceId }: SaveGalleryFile
  ) {
    const token = this.store.selectSnapshot(UserState.token);
    if (token) {
      return this.api.SaveGalleryFile(FilePath, FirebaseId, PlaceId).pipe(
        tap(({ data: { created } }) => {
          const file = JSON.parse(created);
          if (file.id !== "") {
            setState(
              patch({
                galleryImages: insertItem<any>({
                  Route_File: file.Route_File,
                  id: file.id,
                }),
              })
            );
          }
        })
        //trace("SaveGalleryFile")
      );
    }
  }

  @Action(UploadImage)
  uploadImage(
    { dispatch }: StateContext<AdminStateModel>,
    { file, FK_ProductFeature, FK_InventoryDetail, fromCadesur }: UploadImage
  ) {
    const { selectedPlace } = this.store.selectSnapshot(UserState);
    const uuidImage = uuid();
    const FirebaseId = `place_${selectedPlace.id}${environment.bucket_place}/products/feature_${FK_ProductFeature}_${uuidImage}.png`;
    const fileRef = this.storage.ref(FirebaseId);
    const uploadTask = this.storage.upload(FirebaseId, file, {
      customMetadata: { id: FK_ProductFeature.toString() },
    });
    return uploadTask.snapshotChanges().pipe(
      //trace("UploadImage"),
      finalize(() =>
        dispatch(
          new SaveImageRoute(
            fileRef.getDownloadURL(),
            FK_ProductFeature,
            FK_InventoryDetail,
            FirebaseId,
            fromCadesur
          )
        )
      )
    );
  }

  @Action(SaveImageRoute)
  saveImageRoute(
    { dispatch }: StateContext<AdminStateModel>,
    {
      fileRef,
      FK_ProductFeature,
      FK_InventoryDetail,
      FirebaseId,
      fromCadesur,
    }: SaveImageRoute
  ) {
    return fileRef.pipe(
      tap(
        (url) => {
          if (!fromCadesur) {
            dispatch(
              new CreateFeatureFile(
                `${url}`,
                FK_ProductFeature,
                FK_InventoryDetail,
                FirebaseId
              )
            );
          } else {
            dispatch(
              new SetCadesurFeatureFile(
                `${url}`,
                FK_ProductFeature,
                FK_InventoryDetail,
                FirebaseId
              )
            );
          }
        },
        () =>
          this.alertService.openSnackBar("Error al subir la imagen.", "error")
      )
      //trace("SaveImageRoute")
    );
  }

  @Action(CreateFeatureFile)
  createFeatureFile(
    { setState, getState }: StateContext<AdminStateModel>,
    {
      Route_File,
      FK_ProductFeature,
      FK_InventoryDetail,
      FirebaseId,
    }: CreateFeatureFile
  ) {
    const token = this.store.selectSnapshot(UserState.token);
    return this.api
      .createFeatureFile({ FK_ProductFeature, Route_File, FirebaseId })
      .pipe(
        delay(400),
        tap(({ data: { file } }) => {
          const { currentProductFeature } = getState();
          setState(
            patch({
              featuresFiltered: updateItem<any>(
                (xFeature) => xFeature.id === FK_ProductFeature,
                patch({ Files: append([file]) })
              ),
            })
          );
          setState(
            patch({
              ordersToPrepare: updateItem<any>(
                (xB) => xB.ProductFeature.id === FK_ProductFeature,
                patch({
                  ProductFeature: patch({ Files: append([file]) }),
                })
              ),
            })
          );
          setState(
            patch({
              inventoryDetail: updateItem<any>(
                (xI) => xI.id === FK_InventoryDetail,
                patch({
                  Product: patch({
                    Features: updateItem<any>(
                      (xFeature) => xFeature.id === FK_ProductFeature,
                      patch({
                        Files: append([file]),
                      })
                    ),
                  }),
                })
              ),
            })
          );
          if (currentProductFeature) {
            setState(
              patch({
                currentProductFeature: patch({
                  Files: append([file]),
                }),
              })
            );
          }
        })
        //trace("CreateFeatureFile")
      );
  }

  @Action(OpenDialog)
  openDialog(
    {}: StateContext<AdminStateModel>,
    { component, data }: OpenDialog
  ) {}

  @Action(AddProductDetail)
  addProductDetail(
    { setState, getState }: StateContext<AdminStateModel>,
    { _featureDetail, FK_InventoryDetail }: AddProductDetail
  ) {
    const token = this.store.selectSnapshot(UserState.token);
    return this.api.addProductDetail(_featureDetail).pipe(
      tap(
        ({ data: { featureDetail } }) => {
          const { currentProductFeature } = getState();
          setState(
            patch({
              featuresFiltered: updateItem<any>(
                (xFeature) => xFeature.id === featureDetail.FK_ProductFeature,
                patch({ Details: append([featureDetail]) })
              ),
            })
          );
          setState(
            patch({
              ordersToPrepare: updateItem<any>(
                (xB) =>
                  xB.ProductFeature.id === featureDetail.FK_ProductFeature,
                patch({
                  ProductFeature: patch({ Details: append([featureDetail]) }),
                })
              ),
            })
          );
          setState(
            patch({
              inventoryDetail: updateItem<any>(
                (xI) => xI.id === FK_InventoryDetail,
                patch({
                  Product: patch({
                    Features: updateItem<any>(
                      (xFeature) =>
                        xFeature.id === featureDetail.FK_ProductFeature,
                      patch({
                        Details: append([featureDetail]),
                      })
                    ),
                  }),
                })
              ),
            })
          );
          if (currentProductFeature) {
            setState(
              patch({
                currentProductFeature: patch({
                  Details: append([featureDetail]),
                }),
              })
            );
          }
          this.alertService.openSnackBar(
            "Se ha creado un detalle con éxito.",
            "success"
          );
        },
        () => {
          this.alertService.openSnackBar(
            "Error al agregar el detalle del producto.",
            "error"
          );
        }
      )
      //trace("AddProductDetail")
    );
  }

  @Action(UpdateProductDetail)
  updateProductDetail(
    { setState, getState }: StateContext<AdminStateModel>,
    { _featureDetail, FK_InventoryDetail }: UpdateProductDetail
  ) {
    const token = this.store.selectSnapshot(UserState.token);
    return this.api.updateProductDetail(_featureDetail).pipe(
      tap(
        ({ data: { featureDetail } }) => {
          const { currentProductFeature } = getState();
          setState(
            patch({
              featuresFiltered: updateItem<any>(
                (xFeature) => xFeature.id === featureDetail.FK_ProductFeature,
                patch({
                  Details: updateItem<any>(
                    (d) => d.id === featureDetail.id,
                    featureDetail
                  ),
                })
              ),
            })
          );
          setState(
            patch({
              ordersToPrepare: updateItem<any>(
                (xB) =>
                  xB.ProductFeature.id === featureDetail.FK_ProductFeature,
                patch({
                  ProductFeature: patch({
                    Details: updateItem<any>(
                      (d) => d.id === featureDetail.id,
                      featureDetail
                    ),
                  }),
                })
              ),
            })
          );
          setState(
            patch({
              inventoryDetail: updateItem<any>(
                (xI) => xI.id === FK_InventoryDetail,
                patch({
                  Product: patch({
                    Features: updateItem<any>(
                      (xFeature) =>
                        xFeature.id === featureDetail.FK_ProductFeature,
                      patch({
                        Details: updateItem<any>(
                          (d) => d.id === featureDetail.id,
                          featureDetail
                        ),
                      })
                    ),
                  }),
                })
              ),
            })
          );
          if (currentProductFeature) {
            setState(
              patch({
                currentProductFeature: patch({
                  Details: updateItem<any>(
                    (d) => d.id === featureDetail.id,
                    featureDetail
                  ),
                }),
              })
            );
          }
          this.alertService.openSnackBar(
            "Se ha actualizado el detalle del producto con éxito.",
            "success"
          );
        },
        () => {
          this.alertService.openSnackBar(
            "Error al actualizar el detalle del producto.",
            "error"
          );
        }
      )
      //trace("UpdateProductDetail")
    );
  }

  @Action(RemoveProductDetail)
  removeProductDetail(
    { setState, getState }: StateContext<AdminStateModel>,
    { id, FK_InventoryDetail, FK_ProductFeature }: RemoveProductDetail
  ) {
    const token = this.store.selectSnapshot(UserState.token);
    return this.api.removeProductDetail(id).pipe(
      tap(
        () => {
          const { currentProductFeature } = getState();
          setState(
            patch({
              featuresFiltered: updateItem<any>(
                (xFeature) => xFeature.id === FK_ProductFeature,
                patch({
                  Details: removeItem<any>((d) => d.id === id),
                })
              ),
            })
          );
          setState(
            patch({
              ordersToPrepare: updateItem<any>(
                (xB) => xB.ProductFeature.id === FK_ProductFeature,
                patch({
                  ProductFeature: patch({
                    Details: removeItem<any>((d) => d.id === id),
                  }),
                })
              ),
            })
          );
          setState(
            patch({
              inventoryDetail: updateItem<any>(
                (xI) => xI.id === FK_InventoryDetail,
                patch({
                  Product: patch({
                    Features: updateItem<any>(
                      (xFeature) => xFeature.id === FK_ProductFeature,
                      patch({
                        Details: removeItem<any>((d) => d.id === id),
                      })
                    ),
                  }),
                })
              ),
            })
          );
          if (currentProductFeature) {
            setState(
              patch({
                currentProductFeature: patch({
                  Details: removeItem<any>((d) => d.id === id),
                }),
              })
            );
          }
          this.alertService.openSnackBar(
            "Se ha eliminado el detalle del producto con éxito.",
            "success"
          );
        },
        () => {
          this.alertService.openSnackBar(
            "Error al remover el detalle del atículo.",
            "error"
          );
        }
      )
      //trace("RemoveProductDetail")
    );
  }

  @Action(UpdateInventoryAll)
  updateInventoryAll(
    { getState, setState }: StateContext<AdminStateModel>,
    { inventory }: UpdateInventoryAll
  ) {
    const { productId, ...inventoryToSend } = inventory;

    return this.api.updateInventoryAll(inventoryToSend).pipe(
      tap(
        (response) => {
          if (response.data.updateInventoryAll) {
            const state = getState();

            setState(
              patch({
                cellarsForMovement: state.cellarsForMovement.map((cellar) => ({
                  ...cellar,
                  Inventories: cellar.Inventories?.map((inv) => ({
                    ...inv,
                    Products: inv.Products?.map((product) => {
                      if (product.id === inventory.productId) {
                        return {
                          ...product,
                          Features: product.Features?.map((feature) => {
                            const matchingProduct = inventory.products.find(
                              (p) => p.id === feature.id
                            );

                            if (matchingProduct) {
                              return {
                                ...feature,
                                Quantity_ProductFeature:
                                  matchingProduct.quantity,
                                CadesurCode_ProductFeature:
                                  matchingProduct.code,
                                ProductPrice: {
                                  ...feature.ProductPrice,
                                  Price_ProductPrice: matchingProduct.price,
                                  ProductionPrice: matchingProduct.cost,
                                },
                              };
                            }
                            return feature;
                          }),
                        };
                      }
                      return product;
                    }),
                  })),
                })),
              })
            );
          }

          this.alertService.openSnackBar(
            "Se ha actualizado el inventario con éxito.",
            "success"
          );
        },
        (error) => {
          this.alertService.openSnackBar(
            "Error al actualizar el inventario.",
            "error"
          );
        }
      )
    );
  }

  @Action(AddProductFeature)
  addProductFeature(
    { setState, getState }: StateContext<AdminStateModel>,
    { newFeature }: AddProductFeature
  ) {
    const token = this.store.selectSnapshot(UserState.token);
    return this.api.addFeature(newFeature).pipe(
      tap(
        ({ data: { feature } }) => {
          setState(
            produce(getState(), ({ inventoryDetail }: AdminStateModel) => {
              const detail = inventoryDetail.find(
                (_detail) => _detail.id === newFeature.FK_InventoryDetail
              );
              if (detail && detail.Product && detail.Product.Features) {
                detail.Product.Features.push(feature);
              }
            })
          );
          setState(patch({ featuresFiltered: append([feature]) }));
        },
        () =>
          this.alertService.openSnackBar(
            "Error al agregar un feature al producto.",
            "error"
          )
      )
      //trace("AddProductFeature")
    );
  }

  @Action(UpdateProductFeature)
  updateProductFeature(
    { getState, patchState, setState }: StateContext<AdminStateModel>,
    { newPrice, newQuantity, detailId }: UpdateProductFeature
  ) {
    const updatePrice$ = newPrice
      ? this.api.updateFeaturePrice(newPrice)
      : of(null);
    const updateQuantity$ = newQuantity
      ? this.api.updateFeatureQuantity(newQuantity)
      : of(null);

    return forkJoin([updatePrice$, updateQuantity$]).pipe(
      tap(
        ([priceResponse, quantityResponse]) => {
          const price = priceResponse?.data?.price;
          const quantity = quantityResponse?.data?.quantity;
          const { currentProductFeature } = getState();

          if (price) {
            setState(
              patch({
                featuresFiltered: updateItem<any>(
                  (xFeature) => xFeature.id === newPrice.FK_ProductFeature,
                  patch({ ProductPrice: price })
                ),
              })
            );
            setState(
              patch({
                ordersToPrepare: updateItem<any>(
                  (xB) => xB.ProductFeature.id === newPrice.FK_ProductFeature,
                  patch({
                    ProductFeature: patch({ ProductPrice: price }),
                  })
                ),
              })
            );
            setState(
              patch({
                inventoryDetail: updateItem<any>(
                  (xI) => xI.id === detailId,
                  patch({
                    Product: patch({
                      Features: updateItem<any>(
                        (xFeature) =>
                          xFeature.id === newPrice.FK_ProductFeature,
                        patch({ ProductPrice: price })
                      ),
                    }),
                  })
                ),
              })
            );
            if (currentProductFeature) {
              setState(
                patch({ currentProductFeature: patch({ ProductPrice: price }) })
              );
            }
          }

          if (quantity) {
            setState(
              patch({
                featuresFiltered: updateItem<any>(
                  (xFeature) => xFeature.id === newQuantity.id,
                  patch({ Quantity_ProductFeature: quantity })
                ),
              })
            );
            setState(
              patch({
                ordersToPrepare: updateItem<any>(
                  (xB) => xB.ProductFeature.id === newQuantity.id,
                  patch({
                    ProductFeature: patch({
                      Quantity_ProductFeature: quantity,
                    }),
                  })
                ),
              })
            );
            setState(
              patch({
                inventoryDetail: updateItem<any>(
                  (xI) => xI.id === detailId,
                  patch({
                    Product: patch({
                      Features: updateItem<any>(
                        (xFeature) => xFeature.id === newQuantity.id,
                        patch({ Quantity_ProductFeature: quantity })
                      ),
                    }),
                  })
                ),
              })
            );
            if (currentProductFeature) {
              setState(
                patch({
                  currentProductFeature: patch({
                    Quantity_ProductFeature: quantity,
                  }),
                })
              );
            }
          }
        },
        () => {
          this.alertService.openSnackBar(
            "Error al actualizar el producto.",
            "error"
          );
          return of(null);
        }
      )
      //trace("UpdateProductFeature")
    );
  }

  @Action(UpdateProductPrice)
  updateProductPrice(
    { getState, setState }: StateContext<AdminStateModel>,
    { newPrice, detailId }: UpdateProductPrice
  ) {
    return this.api.updateFeaturePrice(newPrice).pipe(
      tap(
        ({ data: { price } }) => {
          const { currentProductFeature } = getState();
          setState(
            patch({
              featuresFiltered: updateItem<any>(
                (xFeature) => xFeature.id === newPrice.FK_ProductFeature,
                patch({ ProductPrice: price })
              ),
            })
          );
          setState(
            patch({
              ordersToPrepare: updateItem<any>(
                (xB) => xB.ProductFeature.id === newPrice.FK_ProductFeature,
                patch({
                  ProductFeature: patch({ ProductPrice: price }),
                })
              ),
            })
          );
          setState(
            patch({
              inventoryDetail: updateItem<any>(
                (xI) => xI.id === detailId,
                patch({
                  Product: patch({
                    Features: updateItem<any>(
                      (xFeature) => xFeature.id === newPrice.FK_ProductFeature,
                      patch({ ProductPrice: price })
                    ),
                  }),
                })
              ),
            })
          );
          if (currentProductFeature) {
            setState(
              patch({ currentProductFeature: patch({ ProductPrice: price }) })
            );
          }
          this.alertService.openSnackBar(
            "Se ha editado el producto con éxito.",
            "success"
          );
        },
        () => {
          this.alertService.openSnackBar(
            "Error al editar el producto.",
            "error"
          );
          return of(null);
        }
      )
      //trace("UpdateProductPrice")
    );
  }

  @Action(UpdateFeatureQuantity)
  updateFeatureQuantity(
    { setState, getState }: StateContext<AdminStateModel>,
    { newQuantity, detailId }: UpdateFeatureQuantity
  ) {
    const token = this.store.selectSnapshot(UserState.token);
    return this.api.updateFeatureQuantity(newQuantity).pipe(
      tap(
        ({ data: { quantity } }) => {
          const { currentProductFeature } = getState();
          setState(
            patch({
              featuresFiltered: updateItem<any>(
                (xFeature) => xFeature.id === newQuantity.id,
                patch({ Quantity_ProductFeature: quantity })
              ),
            })
          );
          setState(
            patch({
              ordersToPrepare: updateItem<any>(
                (xB) => xB.ProductFeature.id === newQuantity.id,
                patch({
                  ProductFeature: patch({ Quantity_ProductFeature: quantity }),
                })
              ),
            })
          );
          setState(
            patch({
              inventoryDetail: updateItem<any>(
                (xI) => xI.id === detailId,
                patch({
                  Product: patch({
                    Features: updateItem<any>(
                      (xFeature) => xFeature.id === newQuantity.id,
                      patch({ Quantity_ProductFeature: quantity })
                    ),
                  }),
                })
              ),
            })
          );
          if (currentProductFeature) {
            setState(
              patch({
                currentProductFeature: patch({
                  Quantity_ProductFeature: quantity,
                }),
              })
            );
          }
        },
        () => {
          this.alertService.openSnackBar(
            "Error al actualizar la cantidad del feature.",
            "error"
          );
          return of(null);
        }
      )
      //trace("UpdateFeatureQuantity")
    );
  }

  @Action(GetPriceHistory)
  GetPriceHistory(
    { patchState }: StateContext<AdminStateModel>,
    { id }: GetPriceHistory
  ) {
    const token = this.store.selectSnapshot(UserState.token);
    patchState({ priceHistory: [] });
    return this.api.getPriceHistory(id).pipe(
      tap(
        ({ data: { prices } }) => patchState({ priceHistory: prices }),
        () =>
          this.alertService.openSnackBar(
            "Error al obtener el historial de precio.",
            "error"
          )
      )
      //trace("GetPriceHistory")
    );
  }

  @Action(RemoveFeatureFile)
  removeFeatureFile(
    { setState, getState }: StateContext<AdminStateModel>,
    { id, detailId, featureId }: RemoveFeatureFile
  ) {
    const token = this.store.selectSnapshot(UserState.token);
    return this.api.removeFeatureFile(id, featureId).pipe(
      tap(
        () => {
          const { currentProductFeature } = getState();
          setState(
            patch({
              featuresFiltered: updateItem<any>(
                (xFeature) => xFeature.id === featureId,
                patch({
                  Files: removeItem<any>((f) => f.id === id),
                })
              ),
            })
          );
          setState(
            patch({
              ordersToPrepare: updateItem<any>(
                (xB) => xB.ProductFeature.id === featureId,
                patch({
                  ProductFeature: patch({
                    Files: removeItem<any>((f) => f.id === id),
                  }),
                })
              ),
            })
          );
          setState(
            patch({
              inventoryDetail: updateItem<any>(
                (xI) => xI.id === detailId,
                patch({
                  Product: patch({
                    Features: updateItem<any>(
                      (xFeature) => xFeature.id === featureId,
                      patch({
                        Files: removeItem<any>((f) => f.id === id),
                      })
                    ),
                  }),
                })
              ),
            })
          );
          if (currentProductFeature) {
            setState(
              patch({
                currentProductFeature: patch({
                  Files: removeItem<any>((f) => f.id === id),
                }),
              })
            );
          }

          this.alertService.openSnackBar(
            "Se ha eliminado la imagen con éxito.",
            "success"
          );
        },
        () => {
          this.alertService.openSnackBar(
            "Error al eliminar la imagen.",
            "error"
          );
        }
      )
      //trace("RemoveFeatureFile")
    );
  }

  @Action(GetFeaturesByDetail)
  GetFeaturesByDetail(
    { dispatch, setState, getState, patchState }: StateContext<AdminStateModel>,
    { id }: GetFeaturesByDetail
  ) {
    const { selectedPlace } = this.store.selectSnapshot(UserState);
    dispatch(new TagsByInventoryDetailPlace(id));

    if (selectedPlace) {
      return this.api.featuresByDetail(id, selectedPlace.id).pipe(
        tap((response) => {
          const features = response?.data?.features || [];

          setState(
            patch({
              inventoryDetail: updateItem<any>(
                (_detail) => _detail.id === id,
                patch({ Product: patch({ Features: features }) })
              ),
            })
          );

          if (features?.length > 0) {
            patchState({ noFeatures: false });
            dispatch(new GetInventoryDetailForSearch(features, id));
          } else {
            patchState({ noFeatures: true });
          }
        }),
        catchError((error) => {
          console.error("Error fetching features by detail:", error);
          patchState({ noFeatures: true });
          return of(null);
        })
      );
    } else {
      patchState({ noFeatures: true });
    }
  }

  @Action(TagsByInventoryDetailPlace)
  TagsByInventoryDetailPlace(
    { patchState }: StateContext<AdminStateModel>,
    { id }: TagsByInventoryDetailPlace
  ) {
    const { selectedPlace } = this.store.selectSnapshot(UserState);
    if (selectedPlace) {
      return this.api.tagsByInventoryDetailPlace(id, selectedPlace.id).pipe(
        tap(({ data: { tagsByInventoryDetailPlace } }) => {
          patchState({ tagsByInventoryDetailPlace });
        })
        //trace("tagsByInventoryDetailPlace")
      );
    }
  }

  @Action(GetInventoryDetailForSearch)
  GetInventoryDetailForSearch(
    { patchState }: StateContext<AdminStateModel>,
    { features, productId }: GetInventoryDetailForSearch
  ) {
    const { selectedPlace } = this.store.selectSnapshot(UserState);
    const id = features[0].Product.Inventory.id;
    return this.api.productsByInventory(id, selectedPlace.id).pipe(
      tap(
        ({ data: { products } }) => {
          const details = products.map((xProduct) =>
            xProduct.id === productId
              ? {
                  ...xProduct,
                  Product: { ...xProduct.Product, Features: features },
                }
              : xProduct
          );
          const product = details.find((xDetail) => xDetail.id === productId);
          patchState({
            inventoryDetail: details,
            navigationMap: {
              cellar: {
                id: features[0].Product.Inventory.Cellar.id,
                Description: features[0].Product.Inventory.Cellar.Description,
              },
              inventory: {
                id: features[0].Product.Inventory.Cellar.id,
                Description: features[0].Product.Inventory.Description,
              },
              product: {
                id: features[0].Product.Inventory.id,
                Name_Product: product.Product.Name_Product,
              },
            },
          });
        },
        () => {
          this.alertService.openSnackBar(
            "Error al obtener el detalle del inventario.",
            "error"
          );
        }
      )
      //trace("GetInventoryDetailForSearch")
    );
  }

  @Action(AddProductTag)
  addProductTag(
    { setState }: StateContext<AdminStateModel>,
    { productTag }: AddProductTag
  ) {
    const token = this.store.selectSnapshot(UserState.token);
    return this.api.addProductTag(productTag).pipe(
      tap(
        ({ data: { tag } }) => {
          setState(
            patch({
              placeData: patch({
                InventoriesDetails: updateItem<any>(
                  (i) => i.Product.id === productTag.FK_Product,
                  patch({
                    Product: patch({
                      Tags: append([tag]),
                    }),
                  })
                ),
              }),
            })
          );
          setState(
            patch({
              inventoryDetail: updateItem<any>(
                (i) => i.Product.id === productTag.FK_Product,
                patch({
                  Product: patch({
                    Tags: append([tag]),
                  }),
                })
              ),
            })
          );
        },
        () =>
          this.alertService.openSnackBar(
            "Error al agregar un tag al producto.",
            "error"
          )
      )
      //trace("AddProductTag")
    );
  }

  @Action(RemoveProductTag)
  removeProductTag(
    { setState }: StateContext<AdminStateModel>,
    { FK_Product, FK_Tag }: RemoveProductTag
  ) {
    const token = this.store.selectSnapshot(UserState.token);
    return this.api.removeProductTag(FK_Product, FK_Tag).pipe(
      tap(
        ({ data: { removed } }) => {
          if (removed) {
            setState(
              patch({
                placeData: patch({
                  InventoriesDetails: updateItem<any>(
                    (i) => i.Product.id === FK_Product,
                    patch({
                      Product: patch({
                        Tags: removeItem<any>((t) => t.id === FK_Tag),
                      }),
                    })
                  ),
                }),
              })
            );
            setState(
              patch({
                inventoryDetail: updateItem<any>(
                  (i) => i.Product.id === FK_Product,
                  patch({
                    Product: patch({
                      Tags: removeItem<any>((t) => t.id === FK_Tag),
                    }),
                  })
                ),
              })
            );
          }
        },
        () => {
          this.alertService.openSnackBar(
            "Error al remover un tag al producto.",
            "error"
          );
        }
      )
      //trace("RemoveProductTag")
    );
  }

  @Action(UpdateInventoryState)
  UpdateInventoryState(
    { patchState, getState, setState }: StateContext<AdminStateModel>,
    { id, State_Inventory }: UpdateInventoryState
  ) {
    return this.api.updateInventoryState(id, State_Inventory).pipe(
      tap(({ data: { inventory } }) => {
        if (inventory) {
          const {
            inventories,
            placeData: { Inventories },
          } = getState();
          setState(
            patch({
              inventories: updateItem<any>(
                (i) => i.id === id,
                patch({ State_Inventory })
              ),
            })
          );
          const inventory = Inventories.find((i) => i.id === id);
          if (inventory) {
            setState(
              patch({
                placeData: patch({
                  Inventories: updateItem<any>(
                    (i) => i.id === id,
                    patch({ State_Inventory })
                  ),
                }),
              })
            );
          }
          setState(
            patch({
              featuresFiltered: updateItem<any>(
                (f) => f.Product.Inventory.id === id,
                patch({
                  Product: patch({
                    Inventory: patch({ State_Inventory }),
                  }),
                })
              ),
            })
          );
        }

        const message =
          State_Inventory === 1
            ? "Se ha activado el inventado con éxito."
            : "Se ha desactivado el inventario con éxito.";

        this.alertService.openSnackBar(message, "success");
      }),
      catchError((error) => {
        this.alertService.openSnackBar(
          "Error al cambiar el estado del inventario.",
          "error"
        );
        return of(error);
      })
    );
  }

  @Action(GenerateFeatureQr)
  generateFeatureQr(
    { getState, patchState }: StateContext<AdminStateModel>,
    { detail, FK_ProductFeature }: GenerateFeatureQr
  ) {
    const { selectedPlace } = this.store.selectSnapshot(UserState);
    if (selectedPlace) {
      const qr = uuid();
      const featureCode = {
        FK_ProductFeature,
        FK_ProductCodeType: 2,
        FeatureCode: qr,
      };
      return this.api
        .createProductFeatureCode(featureCode, selectedPlace.id)
        .pipe(
          tap(({ data: { codes } }) => {
            if (codes) {
              const { inventoryDetail } = getState();
              const inventory = inventoryDetail.find((_i) => _i.id === detail);
              const feature = inventory.Product.Features.find(
                (_feature) => _feature.id === FK_ProductFeature
              );
              feature.Codes = codes;
              patchState({ inventoryDetail });
            }
          })
          //trace("GenerateFeatureQr")
        );
    }
  }

  @Action(GenerateFeatureBarCode)
  generateFeatureBarCode(
    { getState, patchState, setState }: StateContext<AdminStateModel>,
    { detail, FK_ProductFeature, FeatureCode, id }: GenerateFeatureBarCode
  ) {
    const { selectedPlace } = this.store.selectSnapshot(UserState);
    if (selectedPlace) {
      const featureCode = {
        FK_ProductFeature,
        FK_ProductCodeType: 1,
        FeatureCode,
        id,
      };
      return this.api
        .createProductFeatureCode(featureCode, selectedPlace.id)
        .pipe(
          tap(({ data: { codes } }) => {
            const { currentProductFeature } = getState();
            if (codes) {
              if (id) {
                setState(
                  patch({
                    featuresFiltered: updateItem<any>(
                      (xFeature) => xFeature.id === FK_ProductFeature,
                      patch({
                        Codes: updateItem<any>((c) => c.id === id, codes[0]),
                      })
                    ),
                  })
                );
                setState(
                  patch({
                    ordersToPrepare: updateItem<any>(
                      (xB) => xB.ProductFeature.id === FK_ProductFeature,
                      patch({
                        ProductFeature: patch({
                          Codes: updateItem<any>((c) => c.id === id, codes[0]),
                        }),
                      })
                    ),
                  })
                );
                setState(
                  patch({
                    inventoryDetail: updateItem<any>(
                      (xI) => xI.id === detail,
                      patch({
                        Product: patch({
                          Features: updateItem<any>(
                            (xFeature) => xFeature.id === FK_ProductFeature,
                            patch({
                              Codes: updateItem<any>(
                                (c) => c.id === id,
                                codes[0]
                              ),
                            })
                          ),
                        }),
                      })
                    ),
                  })
                );
                if (currentProductFeature) {
                  setState(
                    patch({
                      currentProductFeature: patch({
                        Codes: updateItem<any>((c) => c.id === id, codes[0]),
                      }),
                    })
                  );
                }
              } else {
                setState(
                  patch({
                    featuresFiltered: updateItem<any>(
                      (xFeature) => xFeature.id === FK_ProductFeature,
                      patch({ Codes: codes })
                    ),
                  })
                );
                setState(
                  patch({
                    ordersToPrepare: updateItem<any>(
                      (xB) => xB.ProductFeature.id === FK_ProductFeature,
                      patch({ ProductFeature: patch({ Codes: codes }) })
                    ),
                  })
                );
                setState(
                  patch({
                    inventoryDetail: updateItem<any>(
                      (xI) => xI.id === detail,
                      patch({
                        Product: patch({
                          Features: updateItem<any>(
                            (xFeature) => xFeature.id === FK_ProductFeature,
                            patch({ Codes: codes })
                          ),
                        }),
                      })
                    ),
                  })
                );
                if (currentProductFeature) {
                  setState(
                    patch({ currentProductFeature: patch({ Codes: codes }) })
                  );
                }
              }
            } else {
              this.alertService.openSnackBar(
                "El código ingresado ya está registrado.",
                "success"
              );
            }
          })
          //trace("GenerateFeatureBarCode")
        );
    }
  }

  @Action(GetBillsByPlaceAndState)
  GetBillsByPlaceAndState(
    { patchState }: StateContext<AdminStateModel>,
    { FK_BillState }: GetBillsByPlaceAndState
  ) {
    const { selectedPlace } = this.store.selectSnapshot(UserState);
    if (selectedPlace) {
      const FK_BillDetailState = FK_BillState.find((_s) => _s === 2) ? 1 : 6;
      return this.api
        .getBillsByPlaceAndState(
          selectedPlace.id,
          FK_BillState,
          FK_BillDetailState
        )
        .pipe(
          tap(({ data: { bills } }) => {
            patchState({ orders: bills });
          })
          //trace("GetBillsByPlaceAndState")
        );
    }
  }

  @Action(GetBillDetailByBillAndPlace)
  GetBillDetailByBillAndPlace(
    { patchState }: StateContext<AdminStateModel>,
    { FK_Bill }: GetBillDetailByBillAndPlace
  ) {
    const { selectedPlace } = this.store.selectSnapshot(UserState);
    if (selectedPlace) {
      return this.api
        .getBillDetailByBillAndPlace(FK_Bill, selectedPlace.id)
        .pipe(
          tap(({ data: { details } }) => {
            patchState({ detailOfSelectedBill: details });
          })
          //trace("GetBillDetailByBillAndPlace")
        );
    }
  }

  @Action(CreateDeliveryForPlaceAdmin)
  CreateDeliveryForPlaceAdmin(
    { patchState, dispatch }: StateContext<AdminStateModel>,
    { bills, FK_User }: CreateDeliveryForPlaceAdmin
  ) {
    const { selectedPlace } = this.store.selectSnapshot(UserState);
    if (selectedPlace) {
      return this.api
        .createDeliveryForPlaceAdmin(bills, selectedPlace.id, FK_User)
        .pipe(
          tap(
            ({ data: { delivery } }) => {
              this.store.dispatch(
                new Navigate([`/admin/orders/prepare/${bills[0]}`])
              );

              this.alertService.openSnackBar(
                "Se ha aprobado la orden con éxito.",
                "success"
              );
            },
            () => {
              this.alertService.openSnackBar(
                "Error al aprobar orden.",
                "error"
              );
            }
          )
          //trace("CreateDeliveryForPlaceAdmin")
        );
    }
  }

  @Action(GetDeliveryByUser)
  GetDeliveryByUser({ patchState, dispatch }: StateContext<AdminStateModel>) {
    const token = this.store.selectSnapshot(UserState.token);
    const { id } = this.store.selectSnapshot(UserState.selectedPlace);
    if (token) {
      return this.api.getDeliveryByUser(id).pipe(
        tap(
          ({ data: { delivery } }) => {
            patchState({ deliveryInfo: delivery });
            if (delivery) {
              dispatch(new Navigate(["/admin/orders/prepare"]));
              dispatch(new GetBillDetailsForDelivery());
            } else {
              const {
                Role: { Value_Role },
              } = this.store.selectSnapshot(UserState.selectedPlace);
              if (Value_Role === 1 || Value_Role === 0) {
                dispatch(new Navigate(["/admin/orders/pending"]));
              } else {
                this.alertService.openSnackBar(
                  "Todas las órdenes están completas.",
                  "warn"
                );
              }
            }
          },
          () =>
            this.alertService.openSnackBar("Error al aprobar orden.", "error")
        )
        //trace("GetDeliveryByUser")
      );
    }
  }

  @Action(GetBillDetailsForDelivery)
  GetBillDetailsForDelivery({ patchState }: StateContext<AdminStateModel>) {
    const {
      selectedPlace: { id },
    } = this.store.selectSnapshot(UserState);
    if (id) {
      return this.api.getBillDetailsForDeliveryOrder(id).pipe(
        tap(({ data: { details } }) => {
          patchState({ ordersToPrepare: details });
        })
        //trace("GetBillDetailsForDelivery")
      );
    }
  }

  @Action(UpdateBillDetailState)
  UpdateBillDetailState(
    { patchState, getState }: StateContext<AdminStateModel>,
    { id, state, quantity }: UpdateBillDetailState
  ) {
    const token = this.store.selectSnapshot(UserState.token);
    if (token) {
      return this.api.updateBillDetailState(id, state, quantity).pipe(
        tap(({ data: { detail } }) => {
          if (detail) {
            const { ordersToPrepare } = getState();
            const newDetails = ordersToPrepare.map((xDetail) =>
              xDetail.id === detail.id
                ? quantity === 0
                  ? {
                      ...xDetail,
                      State: detail.State,
                      CheckedByDelivery_BillDetail: quantity,
                    }
                  : { ...xDetail, State: detail.State }
                : xDetail
            );
            patchState({ ordersToPrepare: newDetails });
          }
        })
        //trace("UpdateBillDetailState")
      );
    }
  }

  @Action(CheckBillDetail)
  CheckBillDetail(
    { patchState, getState }: StateContext<AdminStateModel>,
    { id, quantity }: CheckBillDetail
  ) {
    const token = this.store.selectSnapshot(UserState.token);
    if (token) {
      return this.api.checkBillDetail(id, quantity).pipe(
        tap(({ data: { detail } }) => {
          if (detail) {
            const { ordersToPrepare } = getState();
            if (ordersToPrepare) {
              const newOrders = ordersToPrepare.map((_detail) =>
                _detail.id === id
                  ? {
                      ..._detail,
                      State: detail.State,
                      CheckedByDelivery_BillDetail: quantity,
                    }
                  : _detail
              );
              patchState({ ordersToPrepare: newOrders });
            }
          }
        })
        //trace("CheckBillDetail")
      );
    }
  }

  @Action(UpdateDeliveryToReady)
  UpdateDeliveryToReady({
    patchState,
    getState,
    dispatch,
  }: StateContext<AdminStateModel>) {
    const {
      deliveryInfo: { id },
      ordersToPrepare,
    } = getState();
    const details = ordersToPrepare.map((_detail) => {
      return {
        id: _detail.id,
        fbDetailId: _detail.FirebaseId_BillDetail,
        billId: _detail.Bill.id,
        fbBillId: _detail.Bill.FirebaseId_Bill,
      };
    });
    const token = this.store.selectSnapshot(UserState.token);
    if (token) {
      return this.api.updateDeliveryState({ id, FK_DeliveryState: 6 }).pipe(
        tap(({ data: { delivery } }) => {
          if (delivery) {
            this.alertService.openSnackBar(
              "Listo! Gracias por colaborar con nosotros.",
              "success"
            );
            patchState({ deliveryInfo: null });
            dispatch(new UpdateBillDetails());
          }
        })
        //trace("UpdateDeliveryToReady")
      );
    }
  }

  @Action(UpdateBillDetails)
  UpdateBillDetails({
    patchState,
    getState,
    dispatch,
  }: StateContext<AdminStateModel>) {
    const { ordersToPrepare } = getState();
    const details = ordersToPrepare.map((_detail) => {
      return {
        id: _detail.id,
        fbDetailId: _detail.FirebaseId_BillDetail,
        billId: _detail.Bill.id,
        fbBillId: _detail.Bill.FirebaseId_Bill,
      };
    });
    const { token } = this.store.selectSnapshot(UserState);
    if (token) {
      return this.api.updateBillDetailForShopperB(details).pipe(
        tap(({ data: { updated } }) => {
          if (updated) {
            dispatch(new Navigate(["/admin/orders/pending"]));
            patchState({ orders: null, ordersToPrepare: null });
          }
        })
        //trace("UpdateBillDetails")
      );
    }
  }

  @Action(UpdateBillDetailsToDelivered)
  UpdateBillDetailsToDelivered(
    { patchState, getState }: StateContext<AdminStateModel>,
    { details }: UpdateBillDetailsToDelivered
  ) {
    const { selectedPlace } = this.store.selectSnapshot(UserState);
    if (selectedPlace) {
      return this.api
        .updateBillDetailsToDelivered(details, selectedPlace.id)
        .pipe(
          tap(({ data: { updated } }) => {
            if (updated) {
              const { orders } = getState();
              const newOrders = orders
                .map((_o) =>
                  !details.find((_d) => _d.billId === _o.id) ? _o : null
                )
                .filter((_o) => _o);
              patchState({ orders: newOrders });
            }
          })
          //trace("UpdateBillDetailsToDelivered")
        );
    }
  }

  @Action(FindFeaturesByPlace)
  FindFeaturesByPlace(
    { patchState }: StateContext<AdminStateModel>,
    { criteria }: FindFeaturesByPlace
  ) {
    const { selectedPlace } = this.store.selectSnapshot(UserState);
    if (selectedPlace) {
      return this.api.findFeaturesByPlace(criteria, selectedPlace.id).pipe(
        tap(({ data: { featuresFiltered } }) => {
          if (featuresFiltered?.length > 0) {
            patchState({ filteredProducts: featuresFiltered });
            this.store.dispatch(new Navigate(["/admin/search"]));
          } else {
            this.alertService.openSnackBar("Sin resultados.", "error");
          }
        })
        //trace("FindFeaturesByPlace")
      );
    }
  }

  @Action(AddElementToNavigation)
  AddElementToNavigation(
    { patchState, getState }: StateContext<AdminStateModel>,
    { type, value }: AddElementToNavigation
  ) {
    const { navigationMap } = getState();
    switch (type) {
      case "cellar": {
        patchState({
          navigationMap: {
            ...navigationMap,
            cellar: value,
            inventory: null,
            product: null,
          },
        });
        break;
      }
      case "inventory": {
        patchState({
          navigationMap: { ...navigationMap, inventory: value, product: null },
        });
        break;
      }
      case "product": {
        patchState({ navigationMap: { ...navigationMap, product: value } });
        break;
      }
    }
  }

  @Action(GetFilesByPlaceAndType)
  GetFilesByPlaceAndType(
    { patchState, getState }: StateContext<AdminStateModel>,
    { FK_FileType }: GetFilesByPlaceAndType
  ) {
    const { selectedPlace } = this.store.selectSnapshot(UserState);
    if (selectedPlace) {
      return this.api
        .getFilesByPlaceAndType(selectedPlace.id, FK_FileType)
        .pipe(
          tap(({ data: { files } }) => {
            patchState({ galleryImages: files });
          })
          //trace("GetFilesByPlaceAndType")
        );
    }
  }

  @Action(ShoppersByPlace)
  buyersByPlace({ patchState }: StateContext<AdminStateModel>) {
    const { id } = this.store.selectSnapshot(UserState.selectedPlace);
    patchState({ shoppers: [] });
    return this.api.shoppersByPlace(id).pipe(
      tap(
        ({ data: { users } }) => {
          patchState({ shoppers: users });
        } //trace("ShoppersByPlace")
      )
    );
  }

  @Action(FindFeaturesByPlaceForBill)
  findFeaturesByPlaceForBill(
    { patchState, dispatch }: StateContext<AdminStateModel>,
    { criteria }: FindFeaturesByPlaceForBill
  ) {
    const { selectedPlace } = this.store.selectSnapshot(UserState);
    if (selectedPlace) {
      return this.api.findFeaturesByPlace(criteria, selectedPlace.id).pipe(
        tap(({ data: { featuresFiltered } }) => {
          if (featuresFiltered && featuresFiltered.length > 0) {
            patchState({ resultsToAddBill: { Features: featuresFiltered } });
          } else {
            this.alertService.openSnackBar(
              "No existe el producto en este lugar.",
              "error"
            );
          }
        })
        //trace("FindFeaturesByPlaceForBill")
      );
    }
  }

  @Action(ResetTemporalBill)
  ResetTemporalBill({ patchState }: StateContext<AdminStateModel>) {
    patchState({ temporalBill: null });
  }

  @Action(SelectDefaultCashierCoin)
  SelectDefaultCashierCoin(
    { patchState, getState }: StateContext<AdminStateModel>,
    { id }: SelectDefaultCashierCoin
  ) {
    const { coins } = getState();
    patchState({ defaultCashierCoin: coins.find((_c) => _c.id === id) });
  }

  @Action(UpdateDefaultCashierCoin)
  UpdateDefaultCashierCoin({
    patchState,
    getState,
  }: StateContext<AdminStateModel>) {
    const { defaultCashierCoin, coins } = getState();
    if (!defaultCashierCoin && coins.length > 0) {
      patchState({
        defaultCashierCoin: coins.find((_c) => Number(_c.id) === 1),
      });
    }
  }

  @Action(GetUserByCriteriaForTemporaryBill)
  GetUserByCriteriaForTemporaryBill(
    { patchState }: StateContext<AdminStateModel>,
    { criteria }: GetUserByCriteriaForTemporaryBill
  ) {
    const { token } = this.store.selectSnapshot(UserState);
    if (token) {
      return this.api.userByCriteria(criteria).pipe(
        tap(
          ({ data: { userSelected } }) => {
            if (userSelected) {
              patchState({ userSelected });
            } else {
              this.alertService.openSnackBar(
                "Error al obtener el usuario.",
                "error"
              );
            }
          },
          () =>
            this.alertService.openSnackBar(
              "Error al obtener el usuario.",
              "error"
            )
        )
        //trace("GetUserByCriteriaForTemporaryBill")
      );
    }
  }

  @Action(ResetChargedClient)
  ResetChargedClient({ patchState }: StateContext<AdminStateModel>) {
    patchState({
      userSelected: null,
      transactionState: false,
      defaultCashierCoin: null,
      usersForBill: [],
    });
  }

  @Action(CreateBillForCashier)
  CreateBillForCashier(
    { patchState, getState }: StateContext<AdminStateModel>,
    {
      OtherInfo,
      Total_Bill,
      SubTotal_Bill,
      FK_TypeOfPay,
      FK_Account,
      FK_PromotionalCode,
    }: CreateBillForCashier
  ) {
    const { token } = this.store.selectSnapshot(UserState);
    const { temporalBill, userSelected } = getState();
    if (token && temporalBill) {
      const bill = {
        ClientId: userSelected ? userSelected.id : 4,
        Total_Bill,
        SubTotal_Bill,
        FK_TypeOfPay,
        OtherInfo,
        FK_Account,
        FK_PromotionalCode,
      };
      const detail = temporalBill.Detail.map((xDetail) => {
        if (xDetail.Feature) {
          return {
            FK_ProductFeature: xDetail.Feature.id,
            Quantity_BillDetail: xDetail.Quantity_BillDetail,
            SubTotal_BillDetail:
              xDetail.Quantity_BillDetail *
              xDetail.Feature.ProductPrice.Price_ProductPrice,
            Total_BillDetail:
              xDetail.Quantity_BillDetail *
              xDetail.Feature.ProductPrice.Price_ProductPrice,
          };
        }
      });
      return this.api.createBillForCashier(bill, detail).pipe(
        tap(({ data: { newBill } }) => {
          if (newBill) {
            patchState({
              temporalBill: null,
              userSelected: null,
              selectedPromotionalCode: null,
            });
          }
        })
        //trace("CreateBillForCashier")
      );
    }
  }

  @Action(CheckIfAccountIsEnough)
  CheckIfAccountIsEnough(
    { patchState }: StateContext<AdminStateModel>,
    { FK_Account, Total }
  ) {
    const { token } = this.store.selectSnapshot(UserState);
    if (token) {
      return this.api.checkIfAccountIsEnough(FK_Account, Total).pipe(
        tap(({ data: { isEnough } }) => {
          patchState({ insufficientFunds: isEnough });
          if (!isEnough) {
            this.alertService.openSnackBar("Saldo insuficiente.", "error");
          }
        })
        //trace("CheckIfAccountIsEnough")
      );
    }
  }

  @Action(GetAllTaxes)
  GetAllTaxes({ patchState }: StateContext<AdminStateModel>) {
    return this.api.getAllTaxes().pipe(
      tap(({ data: { tax } }) => {
        if (tax) {
          patchState({ tax });
        }
      })
      //trace("GetAllTaxes")
    );
  }

  @Action(AssignNewTaxToProduct)
  AssignNewTaxToProduct(
    { getState, patchState }: StateContext<AdminStateModel>,
    { id, FK_Product }: AssignNewTaxToProduct
  ) {
    const { token } = this.store.selectSnapshot(UserState);
    if (token) {
      return this.api.assignNewTaxToProduct(id, FK_Product).pipe(
        tap(({ data: { tax } }) => {
          const { inventoryDetail } = getState();
          patchState({
            inventoryDetail: inventoryDetail.map((_i) =>
              _i.Product.id === FK_Product
                ? { ..._i, Product: { ..._i.Product, Tax: tax } }
                : _i
            ),
          });
        })
        //trace("AssignNewTaxToProduct")
      );
    }
  }

  @Action(ResetInsufficientFunds)
  ResetInsufficientFunds({ patchState }: StateContext<AdminStateModel>) {
    patchState({ insufficientFunds: true });
  }

  @Action(GetInventoriesByPlace)
  GetInventoriesByPlace({
    patchState,
    getState,
  }: StateContext<AdminStateModel>) {
    const { selectedPlace } = this.store.selectSnapshot(UserState);
    if (selectedPlace) {
      return this.api.getInventoriesByPlace(selectedPlace.id).pipe(
        tap(({ data: { inventories } }) => {
          const { navigationMap } = getState();
          if (navigationMap) {
            patchState({
              inventoriesToAssign: inventories.filter(
                (_i) => _i.id !== navigationMap.inventory.id
              ),
            });
          } else {
            patchState({ inventoriesToAssign: inventories });
          }
          this.alertService.openSnackBar(
            "Inventarios cargados correctamente.",
            "success"
          );
        })
      );
    }
  }

  @Action(CloneInventoryDetail)
  CloneInventoryDetail(
    { patchState }: StateContext<AdminStateModel>,
    { detail }: CloneInventoryDetail
  ) {
    const { token } = this.store.selectSnapshot(UserState);
    if (token) {
      return this.api.cloneInventoryDetail(detail).pipe(
        tap(({ data: { inventoryDetail } }) => {
          if (inventoryDetail) {
            this.alertService.openSnackBar(
              "Se ha clonado el producto con éxito.",
              "success"
            );
          } else {
            this.alertService.openSnackBar(
              "Error al clonar el producto.",
              "error"
            );
          }
        })
        //trace("CloneInventoryDetail")
      );
    }
  }

  @Action(MoveInventoryDetail)
  MoveInventoryDetail(
    { patchState, getState }: StateContext<AdminStateModel>,
    { FK_Inventory, FK_Product }: MoveInventoryDetail
  ) {
    return this.api
      .moveInventoryDetailOfInventory(FK_Inventory, FK_Product)
      .pipe(
        tap(({ data: { result } }) => {
          if (result) {
            const { inventoryDetail } = getState();
            patchState({
              inventoryDetail: inventoryDetail.filter(
                (_d) => _d.Product.id !== FK_Product
              ),
            });
          } else {
            this.alertService.openSnackBar(
              "Error al mover el producto.",
              "error"
            );
          }
        })
        //trace("MoveInventoryDetail")
      );
  }

  @Action(UpdateRestrictedProduct)
  UpdateRestrictedProduct(
    { patchState, getState, setState }: StateContext<AdminStateModel>,
    { id, Restricted_Product }: UpdateRestrictedProduct
  ) {
    const { token } = this.store.selectSnapshot(UserState);
    if (token) {
      return this.api.updateRestrictedProduct(id, Restricted_Product).pipe(
        tap(({ data: { updated } }) => {
          if (updated) {
            const {
              inventoryDetail,
              placeData: { InventoriesDetails },
            } = getState();
            patchState({
              inventoryDetail: inventoryDetail.map((_i) =>
                _i.Product.id === id
                  ? { ..._i, Product: { ..._i.Product, Restricted_Product } }
                  : _i
              ),
            });
            const inventoryDetailData = InventoriesDetails.find(
              (i) => i.id === id
            );
            setState(
              patch({
                placeData: patch({
                  InventoriesDetails: updateItem<any>(
                    (i) => i.id === id,
                    patch({ Product: patch({ Restricted_Product }) })
                  ),
                }),
              })
            );
          }
        })
        //trace("UpdateRestrictedProduct")
      );
    }
  }

  @Action(GetBlackBoxByUser)
  GetBlackBoxByUser({ patchState, dispatch }: StateContext<AdminStateModel>) {
    const { selectedPlace } = this.store.selectSnapshot(UserState);

    return this.api.getBlackBoxByUserAndPlace(selectedPlace.id).pipe(
      tap(({ data: { blackbox } }) => {
        if (blackbox) {
          const Types = {
            Cash: blackbox.Types.filter(
              (_t) =>
                _t.Name_BlackBoxDetailType === "Colón" ||
                _t.Name_BlackBoxDetailType === "Dolar" ||
                _t.Name_BlackBoxDetailType === "Euro"
            ),
            Card: blackbox.Types.filter(
              (_t) =>
                _t.Name_BlackBoxDetailType === "Voucher BAC (dolar)" ||
                _t.Name_BlackBoxDetailType === "Voucher BAC (colón)"
            ),
          };
          patchState({ BlackBox: { ...blackbox, Types } });
        }
      })
      //trace("GetBlackBoxByUser")
    );
  }

  @Action(PayWithAccountFromAdmin)
  PayWithAccountFromAdmin(
    { patchState }: StateContext<AdminStateModel>,
    { FK_Account, Total }: PayWithAccountFromAdmin
  ) {
    const { token } = this.store.selectSnapshot(UserState);
    if (token) {
      const newTotal = CryptoJS.AES.encrypt(
        Total.toString(),
        environment.cryptoAES
      ).toString();
      return this.api.payWithAccountFromCashier(FK_Account, newTotal).pipe(
        tap(({ data: { paid } }) => {
          patchState({ transactionState: paid });
        })
        //trace("PayWithAccountFromAdmin")
      );
    }
  }

  @Action(UpdateBlackBoxDetailOfCashier)
  UpdateBlackBoxDetailOfCashier(
    { patchState }: StateContext<AdminStateModel>,
    { blackBoxDetailInput, otherInfo, FK_Bill }: UpdateBlackBoxDetailOfCashier
  ) {
    const { token } = this.store.selectSnapshot(UserState);
    if (token) {
      blackBoxDetailInput.Value = CryptoJS.AES.encrypt(
        blackBoxDetailInput.Value.toString(),
        environment.cryptoAES
      ).toString();
      return this.api
        .updateBlackBoxDetail(blackBoxDetailInput, otherInfo, FK_Bill)
        .pipe(
          tap(({ data: { editedBlackBoxDetail } }) => {
            if (editedBlackBoxDetail) {
              patchState({ transactionState: true });
            } else {
              patchState({ transactionState: false });
            }
          })
          //trace("UpdateBlackBoxDetailOfCashier")
        );
    }
  }

  @Action(AddUserToPayment)
  AddUserToPayment(
    { patchState, getState }: StateContext<AdminStateModel>,
    { user }: AddUserToPayment
  ) {
    const { usersForBill } = getState();
    patchState({ usersForBill: [...usersForBill, user], userSelected: null });
  }

  @Action(EditUserToPayment)
  EditUserToPayment(
    { patchState, getState }: StateContext<AdminStateModel>,
    { user }: EditUserToPayment
  ) {
    const { usersForBill } = getState();
    patchState({
      usersForBill: usersForBill.map((_u) => (_u.id === user.id ? user : _u)),
    });
  }

  @Action(DeleteItemOfUsersBill)
  DeleteItemOfUsersBill(
    { patchState, getState }: StateContext<AdminStateModel>,
    { id }: DeleteItemOfUsersBill
  ) {
    const { usersForBill } = getState();
    patchState({ usersForBill: usersForBill.filter((_u) => _u.id !== id) });
  }

  @Action(PayBillCashierMultiple)
  PayBillCashierMultiple(
    { dispatch }: StateContext<AdminStateModel>,
    { Values, FK_Bill }: PayBillCashierMultiple
  ) {
    const { token } = this.store.selectSnapshot(UserState);
    if (token) {
      const normalPayGroup = this.groupBy(
        Values.filter((_v) => _v.FK_TypeOfPay !== 4),
        "FK_BlackBoxDetail"
      );
      const accountPayGroup = Values.filter((_v) => _v.FK_TypeOfPay === 4);
      const newObjectArray = Object.keys(normalPayGroup).map((_k) => {
        const FormattedAmount = normalPayGroup[_k].reduce(
          (a, b) => a + Number(b["FormattedAmount"] || 0),
          0
        );
        const Amount = normalPayGroup[_k].reduce(
          (a, b) => a + Number(b["Amount"] || 0),
          0
        );
        return {
          Amount,
          FormattedAmount: FormattedAmount.toString(),
          FK_Account: null,
          FK_BlackBoxDetail: _k,
          FK_TypeOfPay: normalPayGroup[_k][0].FK_TypeOfPay,
        };
      });
      if (accountPayGroup && accountPayGroup.length > 0) {
        dispatch(
          new CheckWalletsAndPayMultiple(
            accountPayGroup,
            newObjectArray,
            FK_Bill
          )
        );
      } else {
        dispatch(
          new FinishMultiplePayment(
            [...accountPayGroup, ...newObjectArray],
            FK_Bill
          )
        );
      }
    }
  }

  @Action(CheckWalletsAndPayMultiple)
  CheckWalletsAndPayMultiple(
    { dispatch, getState }: StateContext<AdminStateModel>,
    { accountGroup, normalGroup, FK_Bill }: CheckWalletsAndPayMultiple
  ) {
    const { token } = this.store.selectSnapshot(UserState);
    if (token) {
      return this.api
        .checkIfAccountsIsEnough(
          accountGroup.map((_a) => {
            return { FK_Account: _a.FK_Account, Total: _a.Amount };
          })
        )
        .pipe(
          tap(({ data: { notEnoughAccounts } }) => {
            if (notEnoughAccounts && notEnoughAccounts.length > 0) {
              let label = "";
              const { usersForBill } = getState();
              const accountPayGroup = usersForBill.filter(
                (_v) => _v.typeOfPay === 4
              );
              accountPayGroup.forEach((_a) => {
                if (notEnoughAccounts.find((_c) => _c === _a.wallet.id)) {
                  label += `${_a.user.Person.Name_Person}, `;
                }
              });
              label += "no tiene(n) saldo suficiente en la billetera.";
              this.alertService.openSnackBar(label, "success");
              return of(null);
            } else {
              dispatch(
                new FinishMultiplePayment(
                  [...accountGroup, ...normalGroup],
                  FK_Bill
                )
              );
            }
          })
        );
    }
  }

  @Action(FinishMultiplePayment)
  FinishMultiplePayment(
    { patchState, getState }: StateContext<AdminStateModel>,
    { finalValues, FK_Bill }
  ) {
    const { token } = this.store.selectSnapshot(UserState);
    if (token) {
      const encryptedData = finalValues.map((_v) => {
        return {
          ..._v,
          Amount: CryptoJS.AES.encrypt(
            _v.Amount.toString(),
            environment.cryptoAES
          ).toString(),
          FormattedAmount: _v.FormattedAmount
            ? CryptoJS.AES.encrypt(
                _v.FormattedAmount.toString(),
                environment.cryptoAES
              ).toString()
            : null,
        };
      });
      const { usersForBill } = getState();
      const binnacle = [];
      usersForBill.forEach((_b) => binnacle.push(JSON.parse(_b.more)));
      return this.api
        .payBillCashierMultiple(
          encryptedData,
          JSON.stringify(binnacle),
          FK_Bill
        )
        .pipe(
          tap(({ data: { paid } }) => {
            patchState({ transactionState: paid });
          })
          //trace("PayBillCashierMultiple")
        );
    }
  }

  groupBy = (value, key) => {
    return value.reduce((rv, x) => {
      (rv[x[key]] = rv[x[key]] || []).push(x);
      return rv;
    }, {});
  };

  @Action(UpdateFeatureLocation)
  UpdateFeatureLocation(
    { getState, setState }: StateContext<AdminStateModel>,
    { id, Location_ProductFeature, FK_InventoryDetail }: UpdateFeatureLocation
  ) {
    return this.api.updateFeatureLocation(id, Location_ProductFeature).pipe(
      tap(
        ({ data: { updated } }) => {
          if (updated) {
            const { currentProductFeature } = getState();
            setState(
              patch({
                featuresFiltered: updateItem<any>(
                  (xFeature) => xFeature.id === id,
                  patch({ Location_ProductFeature })
                ),
              })
            );
            setState(
              patch({
                ordersToPrepare: updateItem<any>(
                  (xB) => xB.ProductFeature.id === id,
                  patch({
                    ProductFeature: patch({ Location_ProductFeature }),
                  })
                ),
              })
            );
            setState(
              patch({
                inventoryDetail: updateItem<any>(
                  (xI) => xI.id === FK_InventoryDetail,
                  patch({
                    Product: patch({
                      Features: updateItem<any>(
                        (xFeature) => xFeature.id === id,
                        patch({ Location_ProductFeature })
                      ),
                    }),
                  })
                ),
              })
            );
            if (currentProductFeature) {
              setState(
                patch({
                  currentProductFeature: patch({ Location_ProductFeature }),
                })
              );
            }
            this.alertService.openSnackBar(
              "Se ha guardado la ubicación interna con éxito.",
              "success"
            );
          }
        },
        () => {
          this.alertService.openSnackBar(
            "Error al guardar la ubicación interna.",
            "error"
          );
        }
      )
    );
  }

  @Action(GetActiveCellarsByPlace)
  GetActiveCellarsByPlace({ patchState }: StateContext<AdminStateModel>) {
    const { selectedPlace } = this.store.selectSnapshot(UserState);
    if (selectedPlace) {
      return this.api.getActiveCellarsByPlace(selectedPlace.id).pipe(
        tap(({ data: { cellars } }) => {
          patchState({ cellarsForMovement: cellars });
        })
      );
    }
  }

  @Action(GetAllTariff)
  GetAllTariff({ patchState }: StateContext<AdminStateModel>) {
    const { selectedPlace } = this.store.selectSnapshot(UserState);
    if (selectedPlace) {
      return this.api.getAllTariff().pipe(
        tap(({ data: { tariff } }) => {
          patchState({ tariff });
        })
      );
    }
  }

  @Action(IsPromotionalCodeValid)
  IsPromotionalCodeValid(
    { patchState }: StateContext<AdminStateModel>,
    { FK_User, UniqueCode_PromotionalCode }: IsPromotionalCodeValid
  ) {
    const { token } = this.store.selectSnapshot(UserState);
    if (token) {
      return this.api
        .isPromotionalCodeValidForCashier(FK_User, UniqueCode_PromotionalCode)
        .pipe(
          tap(({ data: { code } }) => {
            if (code) {
              patchState({
                selectedPromotionalCode: {
                  ...code,
                  UniqueCode_PromotionalCode,
                },
              });
            }
          })
        );
    }
  }

  @Action(ResetPromotionalCodeForCashier)
  ResetPromotionalCodeForCashier({
    patchState,
  }: StateContext<AdminStateModel>) {
    patchState({ selectedPromotionalCode: null });
  }

  @Action(UpdatePreparationTimeOfProductFeature)
  UpdatePreparationTimeOfProductFeature(
    { getState, setState }: StateContext<AdminStateModel>,
    {
      id,
      PreparationTime_ProductFeature,
      FK_InventoryDetail,
    }: UpdatePreparationTimeOfProductFeature
  ) {
    return this.api
      .updatePreparationTimeOfProductFeature(id, PreparationTime_ProductFeature)
      .pipe(
        tap(
          ({ data: { updated } }) => {
            if (updated) {
              const { currentProductFeature } = getState();
              setState(
                patch({
                  featuresFiltered: updateItem<any>(
                    (xFeature) => xFeature.id === id,
                    patch({ PreparationTime_ProductFeature })
                  ),
                })
              );
              setState(
                patch({
                  ordersToPrepare: updateItem<any>(
                    (xB) => xB.ProductFeature.id === id,
                    patch({
                      ProductFeature: patch({
                        PreparationTime_ProductFeature,
                      }),
                    })
                  ),
                })
              );
              setState(
                patch({
                  inventoryDetail: updateItem<any>(
                    (xI) => xI.id === FK_InventoryDetail,
                    patch({
                      Product: patch({
                        Features: updateItem<any>(
                          (xFeature) => xFeature.id === id,
                          patch({ PreparationTime_ProductFeature })
                        ),
                      }),
                    })
                  ),
                })
              );
              if (currentProductFeature) {
                setState(
                  patch({
                    currentProductFeature: patch({
                      PreparationTime_ProductFeature,
                    }),
                  })
                );
              }
              this.alertService.openSnackBar(
                "Se ha guardado el tiempo de preparación con éxito.",
                "success"
              );
            }
          },
          () => {
            this.alertService.openSnackBar(
              "Error al cambiar el tiempo de preparación.",
              "error"
            );
          }
        )
      );
  }

  @Action(UpdateCadesurCodeProductFeature)
  updateCadesurCodeProductFeature(
    { getState, setState }: StateContext<AdminStateModel>,
    {
      id,
      CadesurCode_ProductFeature,
      FK_InventoryDetail,
    }: UpdateCadesurCodeProductFeature
  ) {
    return this.api
      .updateCadesurCodeProductFeature(id, CadesurCode_ProductFeature)
      .pipe(
        tap(
          ({ data: { updated } }) => {
            if (updated) {
              const { currentProductFeature } = getState();
              setState(
                patch({
                  inventoryDetail: updateItem<any>(
                    (xI) => xI.id === FK_InventoryDetail,
                    patch({
                      Product: patch({
                        Features: updateItem<any>(
                          (xFeature) => xFeature.id === id,
                          patch({ CadesurCode_ProductFeature })
                        ),
                      }),
                    })
                  ),
                })
              );
              if (currentProductFeature) {
                setState(
                  patch({
                    currentProductFeature: patch({
                      CadesurCode_ProductFeature,
                    }),
                  })
                );
              }
              setState(
                patch({
                  featuresFiltered: updateItem<any>(
                    (xFeature) => xFeature.id === id,
                    patch({ CadesurCode_ProductFeature })
                  ),
                })
              );
              this.alertService.openSnackBar(
                "Se ha guardado el código de proveedor con éxito.",
                "success"
              );
            }
          },
          () => {
            this.alertService.openSnackBar(
              "Error al guardar el código de proveedor.",
              "error"
            );
          }
        )
      );
  }

  @Action(SearchTagByCategory)
  SearchTagByCategory(
    { patchState }: StateContext<AdminStateModel>,
    { value, categoryId }: SearchTagByCategory
  ) {
    const { token } = this.store.selectSnapshot(UserState);
    if (token) {
      return this.api.searchTagByCategory(value, categoryId).pipe(
        tap(({ data: { tags } }) => {
          patchState({ tagsFiltered: tags });
        })
      );
    }
  }

  @Action(TagsByFather)
  TagsByFather(
    { patchState }: StateContext<AdminStateModel>,
    { father, isAdmin }: TagsByFather
  ) {
    const token = this.store.selectSnapshot(UserState.token);
    return this.api.sonTags(father).pipe(
      tap(
        ({ data: { tags } }) => {
          isAdmin ? patchState({ tags }) : patchState({ tagsFiltered: tags });
        },
        () => this.alertService.openSnackBar("Error de conexión.", "error")
      )
    );
  }

  @Action(FindTags)
  FindTags(
    { patchState }: StateContext<AdminStateModel>,
    { criteria }: FindTags
  ) {
    const token = this.store.selectSnapshot(UserState.token);
    return this.api.searchTags(criteria).pipe(
      tap(
        ({ data: { tags } }) => {
          patchState({ tagsFiltered: tags });
        },
        () =>
          this.alertService.openSnackBar("Error al encontrar tags.", "error")
      )
      //trace("FindTags")
    );
  }

  @Action(CategoriesTagsClient)
  CategoriesTagsClient(
    { patchState }: StateContext<AdminStateModel>,
    { id }: CategoriesTagsClient
  ) {
    const token = this.store.selectSnapshot(UserState.token);
    return this.api.sonTags(id).pipe(
      tap(
        ({ data: { tags } }) => {
          patchState({ categories: tags, subcategories: [] });
        },
        () => this.alertService.openSnackBar("Error de conexión.", "error")
      )
    );
  }

  @Action(SubcategoriesTags)
  SubcategoriesTags(
    { patchState }: StateContext<AdminStateModel>,
    { id }: SubcategoriesTags
  ) {
    const token = this.store.selectSnapshot(UserState.token);
    return this.api.sonTags(id).pipe(
      tap(
        ({ data: { tags } }) => {
          patchState({ subcategories: tags });
        },
        () =>
          this.alertService.openSnackBar(
            "Error al obtener las subcategorías de los tags.",
            "error"
          )
      )
    );
  }

  @Action(TagCategories)
  TagCategories({ patchState }: StateContext<AdminStateModel>) {
    return this.api.allTagsCategory().pipe(
      tap(
        ({ data: { tagsCategory } }) => {
          patchState({ tagsCategory });
        },
        () =>
          this.alertService.openSnackBar(
            "Error al obtener las categorías de tags.",
            "error"
          )
      )
    );
  }

  @Action(SonTags)
  SonTags(
    { patchState, getState }: StateContext<AdminStateModel>,
    { tag }: SonTags
  ) {
    const token = this.store.selectSnapshot(UserState.token);
    return this.api.sonTags(tag.id).pipe(
      tap(
        ({ data: { tags } }) => {
          const { usedTags } = getState();
          const indexTag = usedTags.indexOf(tag);
          let newTags;
          if (indexTag !== -1) {
            newTags = usedTags.slice(0, indexTag + 1);
          } else {
            newTags = [...usedTags, tag];
          }
          patchState({ tags, usedTags: newTags });
        },
        () => this.alertService.openSnackBar("Error de conexión.", "error")
      )
    );
  }

  @Action(TagsByCategory)
  TagsByCategory(
    { patchState }: StateContext<AdminStateModel>,
    { id }: TagsByCategory
  ) {
    const token = this.store.selectSnapshot(UserState.token);
    return this.api.tagsByCategory(id).pipe(
      tap(({ data: { tags } }) => {
        patchState({ tags, usedTags: [] });
      })
    );
  }

  @Action(UpdateTag)
  UpdateTag(
    { getState, patchState }: StateContext<AdminStateModel>,
    { tagUpdate }: UpdateTag
  ) {
    const token = this.store.selectSnapshot(UserState.token);
    return this.api.updateTag(tagUpdate).pipe(
      tap(({ data: { tag } }) => {
        const { usedTags } = getState();
        const newTags = usedTags.map((_tag) =>
          _tag.id === tag.id ? { ..._tag, ...tag } : _tag
        );
        patchState({ usedTags: newTags });
      })
    );
  }

  @Action(GetPromotionalCodes)
  GetPromotionalCodes({ patchState }: StateContext<AdminStateModel>) {
    return this.api.getAllPromotionalCodes().pipe(
      tap(({ data: { codes } }) => {
        patchState({ promotionalCodes: codes });
      })
    );
  }

  @Action(FindTagsToAssign)
  findTagsToAssign(
    { getState, patchState }: StateContext<AdminStateModel>,
    { criteria, fatherId }: FindTagsToAssign
  ) {
    try {
      const token = this.store.selectSnapshot(UserState.token);
      const { tags } = getState();
      return this.api.searchTags(criteria).pipe(
        tap(({ data }) => {
          patchState({
            tagsToAssign: data.tags.filter(
              (tag) =>
                tag.id !== fatherId &&
                !tags.find((added) => added.id === tag.id)
            ),
          });
        })
      );
    } catch (error) {
      this.alertService.openSnackBar("Error de conexión.", "error");
    }
  }

  @Action(AddSonTag)
  AddSonTag(
    { getState, patchState }: StateContext<AdminStateModel>,
    { tag, FK_FatherTag }: AddSonTag
  ) {
    const token = this.store.selectSnapshot(UserState.token);
    return this.api.addSonTag({ FK_Tag: tag.id, FK_FatherTag }).pipe(
      tap(({ data: { created } }) => {
        if (created) {
          const { tags } = getState();
          patchState({ tags: [...tags, tag] });
        }
      })
    );
  }

  @Action(RemoveSonTag)
  RemoveSonTag(
    { getState, patchState }: StateContext<AdminStateModel>,
    { tag }: RemoveSonTag
  ) {
    const token = this.store.selectSnapshot(UserState.token);
    return this.api.removeSonTag(tag).pipe(
      tap(({ data: { newTag } }) => {
        let { tags } = getState();
        tags = tags.filter((xTag) => xTag.id !== tag.FK_Tag);
        patchState({ tags });
      })
    );
  }

  @Action(AddTag)
  AddTag(
    { getState, patchState }: StateContext<AdminStateModel>,
    { tag }: AddTag
  ) {
    const token = this.store.selectSnapshot(UserState.token);
    return this.api.createTag(tag).pipe(
      tap(
        ({ data: { newTag } }) => {
          const { tags } = getState();
          patchState({ tags: [...tags, newTag] });
        },
        () =>
          this.alertService.openSnackBar("Error al agregar un tag.", "error")
      )
    );
  }

  @Action(UpdatePromotionalCode)
  UpdatePromotionalCode(
    { patchState, getState }: StateContext<AdminStateModel>,
    { promotionalCode }: UpdatePromotionalCode
  ) {
    const { token } = this.store.selectSnapshot(UserState);
    if (token) {
      return this.api.updatePromotionalCode(promotionalCode).pipe(
        tap(({ data: { updatedCode } }) => {
          const { promotionalCodes } = getState();
          patchState({
            promotionalCodes: promotionalCodes.map((_p) =>
              _p.id === updatedCode.id
                ? {
                    ..._p,
                    TotalQuantity_PromotionalCode:
                      updatedCode.TotalQuantity_PromotionalCode,
                    EndDate_PromotionalCode:
                      updatedCode.EndDate_PromotionalCode,
                  }
                : _p
            ),
          });
        })
      );
    }
  }

  @Action(UpdatePromotionalCodeState)
  UpdatePromotionalCodeState(
    { patchState, getState }: StateContext<AdminStateModel>,
    { id, FK_PromotionalCodeState }: UpdatePromotionalCodeState
  ) {
    const { token } = this.store.selectSnapshot(UserState);
    if (token) {
      return this.api
        .updatePromotionalCodeState(id, FK_PromotionalCodeState)
        .pipe(
          tap(({ data: { updated } }) => {
            const { promotionalCodes } = getState();
            patchState({
              promotionalCodes: promotionalCodes.map((_p) =>
                _p.id === updated.id
                  ? {
                      ..._p,
                      State: updated.State,
                    }
                  : _p
              ),
            });
          })
        );
    }
  }

  @Action(GenerateRandomPromotionalCodeName)
  GenerateRandomPromotionalCodeName({
    patchState,
  }: StateContext<AdminStateModel>) {
    const { token } = this.store.selectSnapshot(UserState);

    return this.api.generateRandomPromotionalCodeName().pipe(
      tap(({ data: { code } }) => {
        patchState({ randomCode: code });
      })
    );
  }

  @Action(CreatePromotionalCode)
  CreatePromotionalCode(
    { patchState, getState }: StateContext<AdminStateModel>,
    { promotionalCode }: CreatePromotionalCode
  ) {
    const { token } = this.store.selectSnapshot(UserState);
    if (token) {
      return this.api.createPromotionalCode(promotionalCode).pipe(
        tap(({ data: { newCode } }) => {
          const { promotionalCodes } = getState();
          patchState({ promotionalCodes: [...promotionalCodes, newCode] });
        })
      );
    }
  }

  @Action(CreateProductKeyFeature)
  CreateProductKeyFeature(
    { patchState, getState }: StateContext<AdminStateModel>,
    { productKeyFeature }: CreateProductKeyFeature
  ) {
    return this.api.createProductKeyFeature(productKeyFeature).pipe(
      tap(
        ({ data: { newProductKeyFeature } }) => {
          const { keysFeatures } = getState();
          patchState({
            keysFeatures: [...keysFeatures, newProductKeyFeature],
          });
          this.alertService.openSnackBar(
            "Se ha creado un nuevo detalle de producto con éxito.",
            "success"
          );
        },
        () => {
          this.alertService.openSnackBar(
            "Error al crear un nuevo detalle de producto.",
            "error"
          );
        }
      )
    );
  }

  @Action(CreateProductDiscount)
  createProductDiscount(
    { patchState, getState }: StateContext<AdminStateModel>,
    { discount }: CreateProductDiscount
  ) {
    const { token } = this.store.selectSnapshot(UserState);
    if (token) {
      return this.api.createProductDiscount(discount).pipe(
        tap(({ data: { createProductDiscount } }) => {
          const { discounts } = getState();
          if (discount.id) {
            patchState({
              discounts: discounts.map((xDiscount) =>
                xDiscount.id === discount.id ? createProductDiscount : xDiscount
              ),
            });
          } else {
            patchState({ discounts: [...discounts, createProductDiscount] });
          }
        })
      );
    }
  }

  @Action(DiscountsByPlace)
  discountsByPlace(
    { patchState, getState }: StateContext<AdminStateModel>,
    { state }: DiscountsByPlace
  ) {
    const { selectedPlace } = this.store.selectSnapshot(UserState);
    if (selectedPlace) {
      return this.api.discounts(selectedPlace.id, state).pipe(
        tap(({ data: { discounts } }) => {
          patchState({ discounts });
        })
      );
    }
  }

  @Action(SetProductDiscount)
  SetProductDiscount(
    { patchState, getState, setState }: StateContext<AdminStateModel>,
    { discount, id, FK_Detail, FK_Feature }: SetProductDiscount
  ) {
    const { selectedPlace } = this.store.selectSnapshot(UserState);
    if (selectedPlace) {
      return this.api.setProductDiscount(id, discount.id).pipe(
        tap(({ data: { setProductDiscount } }) => {
          const { inventoryDetail } = getState();
          setState(
            patch({
              inventoryDetail: updateItem<any>(
                (d) => d.id === FK_Detail,
                patch({
                  Product: patch({
                    Features: updateItem<any>(
                      (f) => f.ProductPrice.id === id,
                      patch({ Discount: null })
                    ),
                  }),
                })
              ),
            })
          );

          setState(
            patch({
              featuresFiltered: updateItem<any>(
                (xFeature) => xFeature.ProductPrice.id === id,
                patch({
                  ProductPrice: patch({ Discount: discount }),
                })
              ),
            })
          );
        })
      );
    }
  }

  @Action(RemoveProductDiscount)
  RemoveProductDiscount(
    { patchState, getState, setState }: StateContext<AdminStateModel>,
    { discount, id, FK_Detail, FK_Feature }: RemoveProductDiscount
  ) {
    const { token } = this.store.selectSnapshot(UserState);
    if (token) {
      return this.api.removeProductDiscount(id, discount.id).pipe(
        tap(({ data: { removeProductDiscount } }) => {
          const { inventoryDetail } = getState();
          const newInventoryDetail = inventoryDetail.map((detail) => {
            if (detail.id === FK_Detail) {
              const features = detail.Product.Features.map((feature) => {
                if (feature.id === FK_Feature) {
                  return {
                    ...feature,
                    ProductPrice: { ...feature.ProductPrice, Discount: null },
                  };
                }
                return feature;
              });
              return {
                ...detail,
                Product: { ...detail.Product, Features: features },
              };
            }
            return detail;
          });

          setState(
            patch({
              featuresFiltered: updateItem<any>(
                (xFeature) => xFeature.ProductPrice.id === id,
                patch({
                  ProductPrice: patch({ Discount: null }),
                })
              ),
            })
          );
          patchState({ inventoryDetail: newInventoryDetail });
        })
      );
    }
  }

  @Action(SubscribeUsers)
  subscribeUsers({}: StateContext<AdminStateModel>) {
    return this.afm.getToken.pipe(
      switchMap((token) => this.api.subscribeUsers(token))
    );
  }

  @Action(CreateProductFeatureTag)
  CreateProductFeatureTag(
    { getState, setState }: StateContext<AdminStateModel>,
    { features, tag }: CreateProductFeatureTag
  ) {
    const token = this.store.selectSnapshot(UserState.token);
    const ids = features.map((feature) => feature.id);
    return this.api.createProductFeatureTag(ids, tag.id).pipe(
      tap(
        ({ data: { createProductFeatureTag } }) => {
          const { currentProductFeature, inventoryDetail } = getState();
          createProductFeatureTag.map((feature) => {
            if (feature) {
              const inventoryDetailToUpdate = inventoryDetail.find((detail) =>
                detail.Product?.Features?.find((feat) => feat.id === feature)
              );
              setState(
                patch({
                  featuresFiltered: updateItem<any>(
                    (xFeature) => xFeature.id === feature,
                    patch({
                      Tags: append<any>([tag]),
                    })
                  ),
                })
              );
              setState(
                patch({
                  ordersToPrepare: updateItem<any>(
                    (xB) => xB.ProductFeature.id === feature,
                    patch({
                      ProductFeature: patch({
                        Tags: append<any>([tag]),
                      }),
                    })
                  ),
                })
              );
              if (inventoryDetailToUpdate) {
                setState(
                  patch({
                    inventoryDetail: updateItem<any>(
                      (xI) => xI.id === inventoryDetailToUpdate.id,
                      patch({
                        Product: patch({
                          Features: updateItem<any>(
                            (xFeature) => xFeature.id === feature,
                            patch({ Tags: append<any>([tag]) })
                          ),
                        }),
                      })
                    ),
                  })
                );
              }
              if (currentProductFeature) {
                setState(
                  patch({
                    currentProductFeature: patch({
                      Tags: append([tag]),
                    }),
                  })
                );
              }
            }
          });
        },
        () => {
          this.alertService.openSnackBar("Error de conexión.", "error");
          return of(null);
        }
      )
      //trace("CreateProductFeatureTag")
    );
  }

  @Action(RemoveProductFeatureTag)
  removeProductFeatureTag(
    { setState, getState }: StateContext<AdminStateModel>,
    { feature, tag }: RemoveProductFeatureTag
  ) {
    const token = this.store.selectSnapshot(UserState.token);
    return this.api.removeProductFeatureTag(feature.id, tag.id).pipe(
      tap(
        ({ data: { featureDetail } }) => {
          const { inventoryDetail } = getState();
          const inventoryDetailToUpdate = inventoryDetail.find((detail) =>
            detail.Product.Features?.find((feat) => feat.id === feature.id)
          );
          if (inventoryDetailToUpdate) {
            setState(
              patch({
                inventoryDetail: updateItem<any>(
                  (xI) => xI.id === inventoryDetailToUpdate.id,
                  patch({
                    Product: patch({
                      Features: updateItem<any>(
                        (xFeature) => xFeature.id === feature.id,
                        patch({
                          Tags: removeItem<any>((t) => t.id === tag.id),
                        })
                      ),
                    }),
                  })
                ),
              })
            );
          }
          setState(
            patch({
              featuresFiltered: updateItem<any>(
                (xFeature) => xFeature.id === feature.id,
                patch({
                  Tags: removeItem<any>((t) => t.id === tag.id),
                })
              ),
            })
          );
          setState(
            patch({
              ordersToPrepare: updateItem<any>(
                (xB) => xB.ProductFeature.id === feature.id,
                patch({
                  ProductFeature: patch({
                    Tags: removeItem<any>((t) => t.id === tag.id),
                  }),
                })
              ),
            })
          );
          const { currentProductFeature } = getState();
          if (currentProductFeature) {
            setState(
              patch({
                currentProductFeature: patch({
                  Tags: removeItem<any>((t) => t.id === tag.id),
                }),
              })
            );
          }
        },
        () => {
          this.alertService.openSnackBar("Error de conexión.", "error");
        }
      )
      //trace("AddProductDetail")
    );
  }

  @Action(Activities)
  activities({ patchState }: StateContext<AdminStateModel>) {
    return this.api.activities().pipe(
      tap(({ data: { activities } }) => {
        patchState({ activities });
      })
    );
  }

  @Action(SelectUserBill)
  selectUser(
    { patchState, getState, setState }: StateContext<AdminStateModel>,
    { User }: SelectUserBill
  ) {
    const { temporalBill } = getState();
    const userId = User ? User.id : temporalBill.User?.id;

    return this.api.updateBillUser(temporalBill.id, userId).pipe(
      tap(() => {
        setState(
          patch({
            temporalBill: patch({ User: User || null }),
          })
        );
        patchState({ userSelected: User });
      })
    );
  }

  @Action(UsersByCriteria)
  queryUsers(
    { setState }: StateContext<AdminStateModel>,
    { criteria, updated }: UsersByCriteria
  ) {
    const token = this.store.selectSnapshot(UserState.token);
    return this.api.queryUserByCriteria(criteria).pipe(
      tap(({ data: { queryUsers } }) => {
        setState(patch({ queryUsers }));
        const [User] = queryUsers;
        if (updated && User) {
          setState(
            patch({
              temporalBill: patch({ User: User ? User : null }),
            })
          );
          setState(patch({ userSelected: User }));
        }
      })
    );
  }

  @Action(BillsByPlace)
  billsByPlace({
    setState,
    dispatch,
    getState,
  }: StateContext<AdminStateModel>) {
    const selecetPlace = this.store.selectSnapshot(UserState.selectedPlace);
    return this.api.billsByPlace(selecetPlace.id).pipe(
      tap(({ data: { billsByPlace } }: any) => {
        setState(patch({ billingBills: billsByPlace }));
        const { temporalBill } = getState();
        if (!temporalBill && billsByPlace.length > 0) {
          dispatch(new BillByID(billsByPlace[0].id));
        }
      })
    );
  }

  @Action(CreateBillCashier)
  createBillCashier(
    { setState, getState, dispatch }: StateContext<AdminStateModel>,
    { feature, newBill }: CreateBillCashier
  ) {
    const { temporalBill } = getState();
    const selectedPlace = this.store.selectSnapshot(UserState.selectedPlace);
    if (temporalBill && !newBill) {
      dispatch(new AddBillCashier(feature));
    } else {
      const newDetail = {
        FK_ProductFeature: feature.id,
        FK_ProductPromotion: null,
        FK_BillDetailState: 1,
        FK_UnitOfMeasurement:
          feature.Product.InventoryDetail.UnitOfMeasurement.id,
        Quantity_BillDetail: 1,
        SubTotal_BillDetail: feature.ProductPrice.Price_ProductPrice,
        Total_BillDetail: feature.ProductPrice.Price_ProductPrice,
        FK_Place: selectedPlace.id,
      };
      return this.api.createBillCashier(newDetail).pipe(
        tap(({ data: { createBillCashier } }) => {
          if (newBill) {
            setState(patch({ temporalBill: createBillCashier }));
            dispatch(
              new Navigate(
                ["/admin/billing/bills"],
                { id: createBillCashier.id },
                { replaceUrl: true }
              )
            );
          }
          setState(patch({ billingBills: append([createBillCashier]) }));
        })
      );
      dispatch(new BillsByPlace());
    }
  }

  @Action(CreateBillOnly)
  createBillOnly(
    { setState, getState, dispatch }: StateContext<AdminStateModel>,
    { feature, newBill }: CreateBillOnly
  ) {
    const { temporalBill } = getState();
    const selectedPlace = this.store.selectSnapshot(UserState.selectedPlace);
    if (temporalBill && !newBill) {
      dispatch(new AddBillCashier(feature));
    } else {
      return this.api.createBillOnly(selectedPlace.id).pipe(
        tap(({ data: { createBillOnly } }) => {
          if (newBill) {
            setState(patch({ temporalBill: createBillOnly }));
            dispatch(
              new Navigate(
                ["/admin/billing/bills"],
                { id: createBillOnly.id },
                { replaceUrl: true }
              )
            );
          }
          setState(patch({ billingBills: append([createBillOnly]) }));
        })
      );
    }
  }

  @Action(BillByID)
  billByID({ patchState }: StateContext<AdminStateModel>, { id }: BillByID) {
    const token = this.store.selectSnapshot(UserState.token);
    return this.api
      .getBill(id)
      .pipe(
        tap(
          ({ data: { getBill } }: any) =>
            getBill &&
            patchState({ temporalBill: getBill, userSelected: getBill.User })
        )
      );
  }

  @Action(AddBillCashier)
  AddBillCashier(
    { setState, getState, dispatch }: StateContext<AdminStateModel>,
    { feature }: AddBillCashier
  ) {
    const { temporalBill } = getState();
    let exist = temporalBill.Detail.find(
      (xDetail) => xDetail.ProductFeature.id === feature.id
    );
    if (!exist) {
      const newDetail = {
        FK_Bill: temporalBill.id,
        FK_ProductFeature: feature.id,
        FK_ProductPromotion: null,
        FK_BillDetailState: 1,
        FK_UnitOfMeasurement:
          feature.Product.InventoryDetail.UnitOfMeasurement.id,
        Quantity_BillDetail: 1,
        SubTotal_BillDetail: feature.ProductPrice.Price_ProductPrice,
        Total_BillDetail: feature.ProductPrice.Price_ProductPrice,
      };
      return this.api.createBillDetailCashier(newDetail).pipe(
        tap(({ data: { createBillDetailCashier } }) => {
          if (createBillDetailCashier) {
            setState(
              patch({
                temporalBill: patch({
                  Detail: append([createBillDetailCashier]),
                }),
              })
            );
          }
          dispatch(new BillsByPlace());
        })
      );
    } else {
      const Quantity_BillDetail = exist.Quantity_BillDetail + 1;
      const SubTotal_BillDetail =
        exist.ProductFeature.ProductPrice.Price_ProductPrice;
      const Total_BillDetail =
        exist.ProductFeature.ProductPrice.Price_ProductPrice *
        exist.Quantity_BillDetail;
      dispatch(
        new UpdateQuantityBillDetailCashier(
          exist.id,
          Quantity_BillDetail,
          SubTotal_BillDetail,
          Total_BillDetail
        )
      );
    }
  }

  @Action(ReduceBillCashier)
  ReduceBillCashier(
    { setState, getState, dispatch }: StateContext<AdminStateModel>,
    { detail }: ReduceBillCashier
  ) {
    const token = this.store.selectSnapshot(UserState.token);
    const { temporalBill } = getState();
    const exist = temporalBill.Detail.find(
      (xDetail) => xDetail.ProductFeature.id === detail.id
    );
    if (exist) {
      if (exist.Quantity_BillDetail <= 1) {
        dispatch(new RemoveBillCashier(detail));
      }
      const Quantity_BillDetail = exist.Quantity_BillDetail - 1;
      const SubTotal_BillDetail =
        exist.ProductFeature.ProductPrice.Price_ProductPrice;
      const Total_BillDetail =
        exist.ProductFeature.ProductPrice.Price_ProductPrice *
        exist.Quantity_BillDetail;
      dispatch(
        new UpdateQuantityBillDetailCashier(
          exist.id,
          Quantity_BillDetail,
          SubTotal_BillDetail,
          Total_BillDetail
        )
      );
      dispatch(new BillsByPlace());
    }
  }

  @Action(RemoveProductsAndFeature)
  RemoveProductsAndFeatures(
    { setState, getState }: StateContext<AdminStateModel>,
    { id }: RemoveProductsAndFeature
  ) {
    const { inventoryDetail } = getState();
    const existProduct = inventoryDetail.find((xProduct) => xProduct.id === id);
    if (existProduct) {
      return this.api.deleteProductsAndFeature(id).pipe(
        tap(({ data: { deleteProductsAndFeature } }) => {
          if (deleteProductsAndFeature) {
            setState(
              patch({
                inventoryDetail: removeItem<any>(
                  (xProduct) => xProduct.id === id
                ),
              })
            );
          }
        })
      );
    }
  }

  @Action(RemoveBillCashier)
  RemoveBillCashier(
    { dispatch, setState, getState }: StateContext<AdminStateModel>,
    { detail }: RemoveBillCashier
  ) {
    const { temporalBill, billingBills } = getState();
    const exist = temporalBill.Detail.find(
      (xDetail) => xDetail.id === detail.id
    );
    if (exist) {
      return this.api.deleteBillDetailCashier(detail.id).pipe(
        tap(({ data: { deleteBillDetailCashier } }) => {
          if (deleteBillDetailCashier) {
            setState(
              patch({
                temporalBill: patch({
                  Detail: removeItem<any>(
                    (xDetail) => xDetail.id === detail.id
                  ),
                }),
              })
            );
            dispatch(new BillsByPlace());
            if (temporalBill.Detail.length === 1) {
              setState(
                patch({
                  billingBills: removeItem<any>(
                    (bill) => bill.id === temporalBill.id
                  ),
                })
              );
              dispatch(new BillsByPlace());
              const bills = this.store.selectSnapshot(AdminState.billingBills);

              if (bills.length > 0) {
                this.store.dispatch(
                  new Navigate(
                    ["/admin/billing/bills"],
                    { id: bills[0].id },
                    { replaceUrl: true }
                  )
                );
              }
            }
          }
        })
      );
    }
  }

  @Action(UpdateQuantityBillDetailCashier)
  UpdateQuantityBillDetailCashier(
    { dispatch, setState, getState }: StateContext<AdminStateModel>,
    {
      Quantity_BillDetail,
      SubTotal_BillDetail,
      Total_BillDetail,
      id,
    }: UpdateQuantityBillDetailCashier
  ) {
    const token = this.store.selectSnapshot(UserState.token);
    const { temporalBill } = getState();
    const exist = temporalBill.Detail.find((xDetail) => xDetail.id === id);
    return this.api
      .updateBillDetailQuantityCashier(
        id,
        Quantity_BillDetail,
        Total_BillDetail
      )
      .pipe(
        tap(({ data: { updateBillDetailQuantityCashier } }) => {
          if (updateBillDetailQuantityCashier) {
            setState(
              patch({
                temporalBill: patch({
                  Detail: updateItem<any>((xDetail) => xDetail.id === id, {
                    ...exist,
                    Quantity_BillDetail,
                    SubTotal_BillDetail,
                    Total_BillDetail,
                  }),
                }),
              })
            );
          }
          dispatch(new BillsByPlace());
        })
      );
  }

  @Action(PayBillByCashier)
  PayBillByCashier(
    { getState, setState, dispatch }: StateContext<AdminStateModel>,
    { data }: PayBillByCashier
  ) {
    const { temporalBill } = getState();

    if (temporalBill) {
      return this.api.payCartCashier(data).pipe(
        tap(({ data }) => {
          setState(
            patch({
              billingBills: removeItem<any>((xBill) => xBill.id === data.id),
            })
          );

          const { billingBills } = getState();
          if (billingBills && billingBills.length) {
            const bill = billingBills[0];
            dispatch(new BillByID(bill.id));
            dispatch(
              new Navigate(
                ["/admin/billing/bills"],
                { id: bill.id },
                { replaceUrl: true }
              )
            );
          } else {
            dispatch(new Navigate(["/admin/billing/bills"]));
          }
        }),
        catchError(() => {
          this.alertService.openSnackBar("Error al procesar el pago.", "error");
          return null;
        })
      );
    } else {
      return;
    }
  }

  @Action(QueryCabys)
  QueryCabys(
    { patchState }: StateContext<AdminStateModel>,
    { query }: QueryCabys
  ) {
    return this.api.getCabysByCriteria(query).pipe(
      tap(({ data: { getCabysByCriteria } }) => {
        patchState({ cabys: getCabysByCriteria });
      })
    );
  }

  @Action(PlaceData)
  PlaceData(
    { patchState, getState, setState, dispatch }: StateContext<AdminStateModel>,
    { route }: PlaceData
  ) {
    const { selectedPlace } = this.store.selectSnapshot(UserState);
    if (selectedPlace) {
      let join: any = { Cellars: this.api.placeData(selectedPlace.id) };
      if (route.detail) {
        join = {
          ...join,
          Inventories: this.api.getInventories(route.cellar, selectedPlace.id),
          InventoriesDetails: this.api.productsByInventory(
            route.inventory,
            selectedPlace.id
          ),
        };
        dispatch(new FeaturesByInventoryDetail(route.detail, true));
      } else if (route.inventory) {
        join = {
          ...join,
          Inventories: this.api.getInventories(route.cellar, selectedPlace.id),
        };
        dispatch(new FeaturesByInventory(route.inventory, true));
      } else if (route.cellar) {
        dispatch(new FeaturesByCellar(route.cellar, true));
      }
      return forkJoin(join).pipe(
        tap<any>(
          ({
            Cellars: {
              data: { Cellars },
            },
            Inventories,
            InventoriesDetails,
          }) => {
            setState(patch({ placeData: patch({ Cellars }) }));
            if (Inventories) {
              setState(
                patch({
                  placeData: patch({
                    Inventories: Inventories.data.inventories,
                  }),
                })
              );
            }
            if (InventoriesDetails) {
              setState(
                patch({
                  placeData: patch({
                    InventoriesDetails: InventoriesDetails.data.products,
                  }),
                })
              );
            }
          }
        )
        //trace("placeData")
      );
    }
  }

  @Action(FeaturesByCellar)
  FeaturesByCellar(
    { getState, setState }: StateContext<AdminStateModel>,
    { FK_Cellar, newQuery }: FeaturesByCellar
  ) {
    const { selectedPlace } = this.store.selectSnapshot(UserState);
    if (selectedPlace) {
      let offset = 0;
      if (!newQuery) {
        const { featuresFiltered } = getState();
        offset = featuresFiltered.length;
      }
      return this.api
        .featuresByCellar(FK_Cellar, selectedPlace.id, offset)
        .pipe(
          tap(({ data: { featuresByCellar, Inventories } }) => {
            if (newQuery) {
              setState(patch({ featuresFiltered: featuresByCellar }));
            } else {
              setState(patch({ featuresFiltered: append(featuresByCellar) }));
            }
            setState(
              patch({
                placeData: patch({ Inventories, InventoriesDetails: null }),
              })
            );
          })
          //trace("FeaturesByCellar")
        );
    }
  }

  @Action(FeaturesByInventory)
  FeaturesByInventory(
    { getState, setState }: StateContext<AdminStateModel>,
    { FK_Inventory, newQuery }: FeaturesByInventory
  ) {
    const { selectedPlace } = this.store.selectSnapshot(UserState);
    if (selectedPlace) {
      let offset = 0;
      if (!newQuery) {
        const { featuresFiltered } = getState();
        offset = featuresFiltered.length;
      }
      return this.api
        .featuresByInventory(FK_Inventory, selectedPlace.id, offset)
        .pipe(
          tap(
            ({
              data: {
                featuresByInventory: { Features },
                InventoriesDetails,
              },
            }) => {
              setState(patch({ placeData: patch({ InventoriesDetails }) }));
              if (newQuery) {
                setState(patch({ featuresFiltered: Features }));
              } else {
                setState(patch({ featuresFiltered: append(Features) }));
              }
            }
          )
          //trace("featuresByInventory")
        );
    }
  }

  @Action(FeaturesByInventoryDetail)
  FeaturesByInventoryDetail(
    { getState, setState, dispatch }: StateContext<AdminStateModel>,
    { FK_Inventory_Detail, newQuery }: FeaturesByInventoryDetail
  ) {
    const { selectedPlace } = this.store.selectSnapshot(UserState);
    let offset = 0;
    if (!newQuery) {
      const { featuresFiltered } = getState();
      offset = featuresFiltered.length;
    }

    return this.api
      .featuresByInventoryDetail(FK_Inventory_Detail, selectedPlace.id, offset)
      .pipe(
        tap(({ data: { featuresByInventoryDetail } }) => {
          if (newQuery) {
            setState(patch({ featuresFiltered: featuresByInventoryDetail }));
          } else {
            setState(
              patch({ featuresFiltered: append(featuresByInventoryDetail) })
            );
          }
        })
        //trace("FeaturesByInventoryDetail")
      );
  }

  @Action(QueryFeatures)
  QueryFeatures(
    { getState, setState }: StateContext<AdminStateModel>,
    { Criteria, newQuery }: QueryFeatures
  ) {
    const { selectedPlace } = this.store.selectSnapshot(UserState);
    let offset = 0;
    if (!newQuery) {
      const { featuresFiltered } = getState();
      offset = featuresFiltered.length;
    }
    if (selectedPlace) {
      return this.api.queryFeatures(Criteria, selectedPlace.id, offset).pipe(
        tap(({ data: { queryProductFeaturesByPlace } }) => {
          if (newQuery) {
            setState(patch({ featuresFiltered: queryProductFeaturesByPlace }));
            const Inventories: Inventory[] = [];
            const InventoriesDetails: InventoryDetail[] = [];
            setState(
              patch({ placeData: patch({ Inventories, InventoriesDetails }) })
            );
          } else {
            setState(
              patch({ featuresFiltered: append(queryProductFeaturesByPlace) })
            );
          }
        })
        //trace("queryFeatures")
      );
    }
  }

  @Action(RandomByPlace)
  RandomByPlace(
    { getState, setState }: StateContext<AdminStateModel>,
    { newQuery }: RandomByPlace
  ) {
    const { selectedPlace } = this.store.selectSnapshot(UserState);
    let offset = 0;
    if (!newQuery) {
      const { featuresFiltered } = getState();
      offset = featuresFiltered.length;
    }

    return this.api.getRandomByPlace(selectedPlace.id, offset).pipe(
      tap(({ data: { getRandomByPlace } }) => {
        if (newQuery) {
          setState(patch({ featuresFiltered: getRandomByPlace }));
        } else {
          setState(patch({ featuresFiltered: append(getRandomByPlace) }));
        }
      })
      //trace("getRandomByPlace")
    );
  }

  @Action(TagsByInventory)
  TagsByInventory(
    { patchState }: StateContext<AdminStateModel>,
    { id }: TagsByInventory
  ) {
    const { selectedPlace } = this.store.selectSnapshot(UserState);
    if (selectedPlace) {
      return this.api.tagsByInventory(id).pipe(
        tap(({ data: { tagsByInventory } }) => {
          patchState({ tagsByInventoryDetailPlace: tagsByInventory });
        })
        //trace("TagsByInventory")
      );
    }
  }

  @Action(FeatureById)
  featureById(
    { patchState, dispatch }: StateContext<AdminStateModel>,
    { id }: FeatureById
  ) {
    const { token } = this.store.selectSnapshot(UserState);
    dispatch(new CleanCurrentFeature());
    if (token) {
      return this.api.featureById(id).pipe(
        tap(({ data: { featureById } }) => {
          patchState({ currentProductFeature: featureById });
          this.alertService.openSnackBar(
            "Producto obtenido con éxito.",
            "success"
          );
        }),
        catchError((error) => {
          this.alertService.openSnackBar("Error al obtener producto.", "error");

          return of(error);
        })
      );
    }
  }
  @Action(CleanCurrentFeature)
  CleanCurrentFeature({ patchState }: StateContext<AdminStateModel>) {
    patchState({ currentProductFeature: null });
  }

  @Action(DevicesByUser)
  DevicesByUser(
    { patchState, dispatch }: StateContext<AdminStateModel>,
    { id }: DevicesByUser
  ) {
    const { token } = this.store.selectSnapshot(UserState);
    if (token) {
      return this.api.devicesByUser(id).pipe(
        tap(
          ({ data: { devicesByUser } }) => {
            patchState({ devicesByUser });
          } //trace("devicesByUser")
        )
      );
    }
  }

  @Action(SetDiscountState)
  SetDiscountState(
    { setState, dispatch }: StateContext<AdminStateModel>,
    { id, State, remove }: SetDiscountState
  ) {
    const { token } = this.store.selectSnapshot(UserState);
    if (token) {
      return this.api.setDiscountState(id, State).pipe(
        tap(
          ({ data: { SetDiscountState } }) => {
            if (remove) {
              setState(
                patch({ discounts: removeItem<any>((d) => d.id === id) })
              );
            } else {
              setState(
                patch({
                  discounts: updateItem<any>(
                    (d) => d.id === id,
                    patch({ State })
                  ),
                })
              );
            }
          } //trace("SetDiscountState")
        )
      );
    }
  }

  @Action(UpdateFeaturesQuantity)
  updateFeaturesQuantity(
    { getState, setState }: StateContext<AdminStateModel>,
    { newQuantity, FK_InventoryDetail, features }: UpdateFeaturesQuantity
  ) {
    const token = this.store.selectSnapshot(UserState.token);
    return this.api.updateFeaturesQuantity(features, newQuantity).pipe(
      tap(
        () => {
          if (FK_InventoryDetail) {
            setState(
              produce(getState(), ({ inventoryDetail }) => {
                inventoryDetail
                  .filter((xInventory) => xInventory.id === FK_InventoryDetail)
                  .forEach((xInventory) => {
                    xInventory.Product.Features =
                      xInventory.Product.Features.map((xFeature) => ({
                        ...xFeature,
                        Quantity_ProductFeature: newQuantity,
                      }));
                  });
              })
            );
          }
        },
        () => {
          this.alertService.openSnackBar(
            "Error al actualizar la cantidad del feature.",
            "error"
          );
          return of(null);
        }
      )
      //trace("UpdateFeatureQuantity")
    );
  }

  @Action(UpdateDeliveryMoment)
  UpdateDeliveryMoment(
    { patchState, setState }: StateContext<AdminStateModel>,
    { id, DeliveryMoment }: UpdateDeliveryMoment
  ) {
    const { token } = this.store.selectSnapshot(UserState);
    if (token) {
      return this.api.updateDeliveryMoment(id, DeliveryMoment).pipe(
        tap(
          ({ data: { updateDeliveryMoment } }) => {
            updateDeliveryMoment &&
              setState(patch({ temporalBill: patch({ DeliveryMoment }) }));
          } //trace("UpdateDeliveryMoment")
        )
      );
    }
  }

  @Action(LocationsByPlace)
  locationsByPlace({ setState }: StateContext<AdminStateModel>) {
    const { selectedPlace } = this.store.selectSnapshot(UserState);
    return this.api
      .locationsByPlace(selectedPlace.id)
      .pipe(
        tap(({ data: { locationsByPlace: locations } }) =>
          setState(patch({ locations }))
        )
      );
  }

  @Action(updateRefundState)
  updateRefundState(
    { setState, getState, patchState }: StateContext<AdminStateModel>,
    { refund }: updateRefundState
  ) {
    const token = this.store.selectSnapshot(UserState.token);
    return this.api.updateRefundState(refund).pipe(
      tap(({ data: { updated } }) => {
        if (updated.State == 1) {
          setState(
            patch({
              orders: updateItem<any>(
                (xB) => xB.id == updated.FK_Bill,
                patch({
                  Refund: patch({
                    State: updated.State,
                  }),
                })
              ),
            })
          );
        }
      })
      //trace("updateRefundState")
    );
  }

  @Action(updateGalleryFileState)
  updateGalleryFileState(
    { setState }: StateContext<AdminStateModel>,
    { id }: updateGalleryFileState
  ) {
    return this.api.updateGalleryFileState(id).pipe(
      tap(({ data: { updated } }) => {
        if (updated.State === 0) {
          setState(
            patch({
              galleryImages: removeItem<any>((p) => p.id === updated.id),
            })
          );
        }
      })
      //trace("updateGalleryFileState")
    );
  }

  @Action(AllPersonTypes)
  allPersonTypes({ patchState }: StateContext<ElectronicBillModel>) {
    return this.api.allPersonTypes().pipe(
      tap(({ data: { personTypes } }) => {
        patchState({ personTypes });
      })
    );
  }

  @Action(LoadTags)
  loadTags({ setState, getState }: StateContext<AdminStateModel>) {
    return this.api.sonTags(4).pipe(
      tap(
        (res) => {
          const state = getState();
          setState({
            ...state,
            tags: res.data.tags,
          });
        },
        (error) => {
          this.alertService.openSnackBar(error, "error");
          const state = getState();
          setState({
            ...state,
            tags: [],
          });
        }
      )
    );
  }

  @Action(SaveTag)
  saveTag(
    { patchState, dispatch }: StateContext<AdminStateModel>,
    action: SaveTag
  ) {
    return this.api.saveTag(action.payload).pipe(
      tap(
        (res) => {
          if (res) {
            patchState({ tags: res.data.tags });
            this.alertService.openSnackBar(
              "Se ha creado una categoría con éxito.",
              "success"
            );
            dispatch(new LoadTags());
          }
        },
        () => {
          this.alertService.openSnackBar(
            "Ha ocurrido un error al crear una categoría.",
            "error"
          );
        }
      )
    );
  }

  @Action(EditFeatureTag)
  editFeatureTag(
    { dispatch }: StateContext<AdminStateModel>,
    action: EditFeatureTag
  ) {
    return this.api.editTag(action.feature.feature.id, action.tagId).pipe(
      tap((res) => {
        if (res) {
          dispatch(new GetFeaturesByDetail(action.feature.detailId));
        }
      })
    );
  }

  @Action(ResetBillDetail)
  resetBillDetail(ctx: StateContext<AdminStateModel>) {
    ctx.patchState({ detailOfSelectedBill: null });
  }

  @Action(RemoveTag)
  removeTag(
    { getState, setState }: StateContext<AdminStateModel>,
    action: RemoveTag
  ) {
    const state = getState();
    const updatedTags = state.tags.filter((tag) => tag.id !== action.id);
    setState({
      ...state,
      tags: updatedTags,
    });
  }

  @Action(UpdateFeatureState)
  updateFeatureState(
    { setState, getState }: StateContext<AdminStateModel>,
    { featureId, action }: UpdateFeatureState
  ) {
    return this.api.updateFeatureState(featureId, action).pipe(
      tap(
        ({ data: { response } }) => {
          const feature = response;
          if (feature) {
            setState(
              produce(getState(), ({ featuresFiltered }) => {
                const idx = featuresFiltered.findIndex(
                  (f) => f.id === feature.id
                );
                if (idx > -1) {
                  featuresFiltered[idx].FK_ProductFeatureState =
                    feature.FK_ProductFeatureState;
                }
              })
            );

            setState(
              patch({
                placeData: patch({
                  InventoriesDetails: updateItem<any>(
                    (inv) =>
                      inv.Product.Features?.some((f) => f.id === feature.id),
                    patch({
                      Product: patch({
                        Features: updateItem<any>(
                          (f) => f.id === feature.id,
                          patch({
                            FK_ProductFeatureState:
                              feature.FK_ProductFeatureState,
                          })
                        ),
                      }),
                    })
                  ),
                }),
              })
            );

            this.alertService.openSnackBar(
              "Se ha actualizado el estado del feature con éxito.",
              "success"
            );
          }
        },
        () => {
          this.alertService.openSnackBar(
            "Error al cambiar el estado del feature.",
            "error"
          );
        }
      )
    );
  }
}
